/* tslint:disable */
/* eslint-disable */
/**
 * ProjectDevelopment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AddEditBrandCommand
 */
export interface AddEditBrandCommand {
    /**
     * 
     * @type {Brand}
     * @memberof AddEditBrandCommand
     */
    Model?: Brand;
}
/**
 * 
 * @export
 * @interface AddEditCategoryCommand
 */
export interface AddEditCategoryCommand {
    /**
     * 
     * @type {Category}
     * @memberof AddEditCategoryCommand
     */
    Model?: Category;
}
/**
 * 
 * @export
 * @interface AddEditComponentCommand
 */
export interface AddEditComponentCommand {
    /**
     * 
     * @type {Component}
     * @memberof AddEditComponentCommand
     */
    Model?: Component;
}
/**
 * 
 * @export
 * @interface AddEditDepartmentCommand
 */
export interface AddEditDepartmentCommand {
    /**
     * 
     * @type {Department}
     * @memberof AddEditDepartmentCommand
     */
    Model?: Department;
}
/**
 * 
 * @export
 * @interface AddEditModuleCommand
 */
export interface AddEditModuleCommand {
    /**
     * 
     * @type {Module}
     * @memberof AddEditModuleCommand
     */
    Model?: Module;
}
/**
 * 
 * @export
 * @interface AddEditProductTypeCommand
 */
export interface AddEditProductTypeCommand {
    /**
     * 
     * @type {ProductType}
     * @memberof AddEditProductTypeCommand
     */
    Model?: ProductType;
}
/**
 * 
 * @export
 * @interface AddEditTestCommand
 */
export interface AddEditTestCommand {
    /**
     * 
     * @type {Test}
     * @memberof AddEditTestCommand
     */
    Model?: Test;
}
/**
 * 
 * @export
 * @interface AddEditVendorCommand
 */
export interface AddEditVendorCommand {
    /**
     * 
     * @type {Vendor}
     * @memberof AddEditVendorCommand
     */
    Model?: Vendor;
}
/**
 * 
 * @export
 * @interface AddModuleMessageCommand
 */
export interface AddModuleMessageCommand {
    /**
     * 
     * @type {number}
     * @memberof AddModuleMessageCommand
     */
    MatrixItemModuleId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddModuleMessageCommand
     */
    ParentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AddModuleMessageCommand
     */
    Text?: string | null;
}
/**
 * 
 * @export
 * @interface AddProductToMatrixCommand
 */
export interface AddProductToMatrixCommand {
    /**
     * 
     * @type {number}
     * @memberof AddProductToMatrixCommand
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof AddProductToMatrixCommand
     */
    MatrixYear?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AddProductToMatrixCommand
     */
    ProductIds?: Array<number> | null;
    /**
     * 
     * @type {Array<ModuleIdAndDeadline>}
     * @memberof AddProductToMatrixCommand
     */
    ChooseModules?: Array<ModuleIdAndDeadline> | null;
}
/**
 * 
 * @export
 * @interface AddRemoveMatrixModuleVendor
 */
export interface AddRemoveMatrixModuleVendor {
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof AddRemoveMatrixModuleVendor
     */
    Vendors?: Array<Vendor> | null;
    /**
     * 
     * @type {Array<Module>}
     * @memberof AddRemoveMatrixModuleVendor
     */
    Modules?: Array<Module> | null;
    /**
     * 
     * @type {Array<VendorWithModuleChosen>}
     * @memberof AddRemoveMatrixModuleVendor
     */
    VendorWithModuleChosens?: Array<VendorWithModuleChosen> | null;
}
/**
 * 
 * @export
 * @interface AddRemoveMatrixModuleVendorCommmand
 */
export interface AddRemoveMatrixModuleVendorCommmand {
    /**
     * 
     * @type {number}
     * @memberof AddRemoveMatrixModuleVendorCommmand
     */
    MatrixItemId?: number;
    /**
     * 
     * @type {Array<VendorWithModuleChosen>}
     * @memberof AddRemoveMatrixModuleVendorCommmand
     */
    VendorWithModuleChosens?: Array<VendorWithModuleChosen> | null;
}
/**
 * 
 * @export
 * @interface AddRemoveMatrixModuleVendorResult
 */
export interface AddRemoveMatrixModuleVendorResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddRemoveMatrixModuleVendorResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AddRemoveMatrixModuleVendorResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {AddRemoveMatrixModuleVendor}
     * @memberof AddRemoveMatrixModuleVendorResult
     */
    Data?: AddRemoveMatrixModuleVendor;
}
/**
 * 
 * @export
 * @interface AddRemoveModuleMatrixItemCommand
 */
export interface AddRemoveModuleMatrixItemCommand {
    /**
     * 
     * @type {number}
     * @memberof AddRemoveModuleMatrixItemCommand
     */
    MatrixItemId?: number;
    /**
     * 
     * @type {Array<ModuleIdAndDeadline>}
     * @memberof AddRemoveModuleMatrixItemCommand
     */
    ChooseModules?: Array<ModuleIdAndDeadline> | null;
}
/**
 * 
 * @export
 * @interface AssignTestToProductsCommand
 */
export interface AssignTestToProductsCommand {
    /**
     * 
     * @type {number}
     * @memberof AssignTestToProductsCommand
     */
    TestId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof AssignTestToProductsCommand
     */
    MatrixItemModuleIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface AssignedProductModel
 */
export interface AssignedProductModel {
    /**
     * 
     * @type {number}
     * @memberof AssignedProductModel
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignedProductModel
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductModel
     */
    Year?: number;
}
/**
 * 
 * @export
 * @interface AssignedProductModelPaginatedResult
 */
export interface AssignedProductModelPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssignedProductModelPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignedProductModelPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<AssignedProductModel>}
     * @memberof AssignedProductModelPaginatedResult
     */
    Data?: Array<AssignedProductModel> | null;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductModelPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductModelPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductModelPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductModelPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface AssignedProductRequestModel
 */
export interface AssignedProductRequestModel {
    /**
     * 
     * @type {number}
     * @memberof AssignedProductRequestModel
     */
    Page?: number;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductRequestModel
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof AssignedProductRequestModel
     */
    Search?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssignedProductRequestModel
     */
    SortField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssignedProductRequestModel
     */
    IsDescending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssignedProductRequestModel
     */
    GetOnlyActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof AssignedProductRequestModel
     */
    TestId?: number;
}
/**
 * 
 * @export
 * @interface BooleanApiResponse
 */
export interface BooleanApiResponse {
    /**
     * 
     * @type {boolean}
     * @memberof BooleanApiResponse
     */
    Data?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BooleanApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BooleanApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof BooleanApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface BooleanResult
 */
export interface BooleanResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BooleanResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BooleanResult
     */
    Data?: boolean;
}
/**
 * 
 * @export
 * @interface Brand
 */
export interface Brand {
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Brand
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Brand
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Brand
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Brand
     */
    States?: StatesEnum;
}
/**
 * 
 * @export
 * @interface BrandPaginatedResult
 */
export interface BrandPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BrandPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Brand>}
     * @memberof BrandPaginatedResult
     */
    Data?: Array<Brand> | null;
    /**
     * 
     * @type {number}
     * @memberof BrandPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof BrandPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface BrandResult
 */
export interface BrandResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof BrandResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Brand}
     * @memberof BrandResult
     */
    Data?: Brand;
}
/**
 * 
 * @export
 * @interface CBrand
 */
export interface CBrand {
    /**
     * 
     * @type {number}
     * @memberof CBrand
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof CBrand
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CBrand
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof CBrand
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {StatesEnum}
     * @memberof CBrand
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<ComponentBrand>}
     * @memberof CBrand
     */
    ComponentBrands?: Array<ComponentBrand> | null;
}
/**
 * 
 * @export
 * @interface CBrandModel
 */
export interface CBrandModel {
    /**
     * 
     * @type {number}
     * @memberof CBrandModel
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof CBrandModel
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CBrandModel
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CBrandModel
     */
    ComponentIds?: Array<number> | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof CBrandModel
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CBrandModel
     */
    ComponentNames?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CBrandModel
     */
    ProductTypeName?: string | null;
}
/**
 * 
 * @export
 * @interface CBrandModelApiResponse
 */
export interface CBrandModelApiResponse {
    /**
     * 
     * @type {CBrandModel}
     * @memberof CBrandModelApiResponse
     */
    Data?: CBrandModel;
    /**
     * 
     * @type {string}
     * @memberof CBrandModelApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CBrandModelApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof CBrandModelApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface CBrandModelIEnumerableApiResponse
 */
export interface CBrandModelIEnumerableApiResponse {
    /**
     * 
     * @type {Array<CBrandModel>}
     * @memberof CBrandModelIEnumerableApiResponse
     */
    Data?: Array<CBrandModel> | null;
    /**
     * 
     * @type {string}
     * @memberof CBrandModelIEnumerableApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CBrandModelIEnumerableApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof CBrandModelIEnumerableApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface CBrandPagingRequestModel
 */
export interface CBrandPagingRequestModel {
    /**
     * 
     * @type {number}
     * @memberof CBrandPagingRequestModel
     */
    Page?: number;
    /**
     * 
     * @type {number}
     * @memberof CBrandPagingRequestModel
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof CBrandPagingRequestModel
     */
    Search?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CBrandPagingRequestModel
     */
    SortField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CBrandPagingRequestModel
     */
    IsDescending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CBrandPagingRequestModel
     */
    GetOnlyActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CBrandPagingRequestModel
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof CBrandPagingRequestModel
     */
    ComponentId?: number;
}
/**
 * 
 * @export
 * @interface CModel
 */
export interface CModel {
    /**
     * 
     * @type {number}
     * @memberof CModel
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof CModel
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CModel
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof CModel
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof CModel
     */
    ComponentId?: number;
    /**
     * 
     * @type {Component}
     * @memberof CModel
     */
    Component?: Component;
    /**
     * 
     * @type {number}
     * @memberof CModel
     */
    CBrandId?: number;
    /**
     * 
     * @type {CBrand}
     * @memberof CModel
     */
    CBrand?: CBrand;
    /**
     * 
     * @type {StatesEnum}
     * @memberof CModel
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<Test>}
     * @memberof CModel
     */
    Tests?: Array<Test> | null;
}
/**
 * 
 * @export
 * @interface CModelModel
 */
export interface CModelModel {
    /**
     * 
     * @type {number}
     * @memberof CModelModel
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof CModelModel
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CModelModel
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof CModelModel
     */
    ProductTypeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CModelModel
     */
    ComponentId?: number;
    /**
     * 
     * @type {string}
     * @memberof CModelModel
     */
    ComponentName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CModelModel
     */
    CBrandId?: number;
    /**
     * 
     * @type {string}
     * @memberof CModelModel
     */
    CBrandName?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof CModelModel
     */
    States?: StatesEnum;
}
/**
 * 
 * @export
 * @interface CModelModelApiResponse
 */
export interface CModelModelApiResponse {
    /**
     * 
     * @type {CModelModel}
     * @memberof CModelModelApiResponse
     */
    Data?: CModelModel;
    /**
     * 
     * @type {string}
     * @memberof CModelModelApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CModelModelApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof CModelModelApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface CModelModelIEnumerableApiResponse
 */
export interface CModelModelIEnumerableApiResponse {
    /**
     * 
     * @type {Array<CModelModel>}
     * @memberof CModelModelIEnumerableApiResponse
     */
    Data?: Array<CModelModel> | null;
    /**
     * 
     * @type {string}
     * @memberof CModelModelIEnumerableApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CModelModelIEnumerableApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof CModelModelIEnumerableApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface CModelPagingRequestModel
 */
export interface CModelPagingRequestModel {
    /**
     * 
     * @type {number}
     * @memberof CModelPagingRequestModel
     */
    Page?: number;
    /**
     * 
     * @type {number}
     * @memberof CModelPagingRequestModel
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof CModelPagingRequestModel
     */
    Search?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CModelPagingRequestModel
     */
    SortField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CModelPagingRequestModel
     */
    IsDescending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CModelPagingRequestModel
     */
    GetOnlyActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CModelPagingRequestModel
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof CModelPagingRequestModel
     */
    ComponentId?: number;
    /**
     * 
     * @type {number}
     * @memberof CModelPagingRequestModel
     */
    CBrandId?: number;
}
/**
 * 
 * @export
 * @interface Category
 */
export interface Category {
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Category
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Category
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Category
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Category
     */
    States?: StatesEnum;
}
/**
 * 
 * @export
 * @interface CategoryPaginatedResult
 */
export interface CategoryPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Category>}
     * @memberof CategoryPaginatedResult
     */
    Data?: Array<Category> | null;
    /**
     * 
     * @type {number}
     * @memberof CategoryPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof CategoryPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface CategoryResult
 */
export interface CategoryResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof CategoryResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof CategoryResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Category}
     * @memberof CategoryResult
     */
    Data?: Category;
}
/**
 * 
 * @export
 * @interface ChangePasswordCommand
 */
export interface ChangePasswordCommand {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordCommand
     */
    Password: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordCommand
     */
    NewPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordCommand
     */
    ConfirmNewPassword: string;
}
/**
 * 
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    Email: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    CurrentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    NewPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordRequest
     */
    ConfirmPassword: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum CompanyTypeEnum {
    SallingGroup = 'SallingGroup',
    Vendor = 'Vendor'
}

/**
 * 
 * @export
 * @interface Component
 */
export interface Component {
    /**
     * 
     * @type {number}
     * @memberof Component
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Component
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Component
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Component
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Component
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<Module>}
     * @memberof Component
     */
    Modules?: Array<Module> | null;
}
/**
 * 
 * @export
 * @interface ComponentBrand
 */
export interface ComponentBrand {
    /**
     * 
     * @type {number}
     * @memberof ComponentBrand
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof ComponentBrand
     */
    CBrandId?: number;
    /**
     * 
     * @type {CBrand}
     * @memberof ComponentBrand
     */
    CBrand?: CBrand;
    /**
     * 
     * @type {number}
     * @memberof ComponentBrand
     */
    ComponentId?: number;
    /**
     * 
     * @type {Component}
     * @memberof ComponentBrand
     */
    Component?: Component;
}
/**
 * 
 * @export
 * @interface ComponentPaginatedResult
 */
export interface ComponentPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComponentPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Component>}
     * @memberof ComponentPaginatedResult
     */
    Data?: Array<Component> | null;
    /**
     * 
     * @type {number}
     * @memberof ComponentPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ComponentPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ComponentPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ComponentPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface ComponentResult
 */
export interface ComponentResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ComponentResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ComponentResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Component}
     * @memberof ComponentResult
     */
    Data?: Component;
}
/**
 * 
 * @export
 * @interface ContactVendor
 */
export interface ContactVendor {
    /**
     * 
     * @type {number}
     * @memberof ContactVendor
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof ContactVendor
     */
    VendorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ContactVendor
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactVendor
     */
    Email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ContactVendor
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {Vendor}
     * @memberof ContactVendor
     */
    Vendor?: Vendor;
}
/**
 * 
 * @export
 * @interface Department
 */
export interface Department {
    /**
     * 
     * @type {number}
     * @memberof Department
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Department
     */
    Name?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Department
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof Department
     */
    ProductTypes?: Array<ProductType> | null;
}
/**
 * 
 * @export
 * @interface DepartmentPaginatedResult
 */
export interface DepartmentPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Department>}
     * @memberof DepartmentPaginatedResult
     */
    Data?: Array<Department> | null;
    /**
     * 
     * @type {number}
     * @memberof DepartmentPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof DepartmentPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface DepartmentResult
 */
export interface DepartmentResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Department}
     * @memberof DepartmentResult
     */
    Data?: Department;
}
/**
 * 
 * @export
 * @interface DepartmentWithCountUser
 */
export interface DepartmentWithCountUser {
    /**
     * 
     * @type {number}
     * @memberof DepartmentWithCountUser
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof DepartmentWithCountUser
     */
    Name?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof DepartmentWithCountUser
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof DepartmentWithCountUser
     */
    ProductTypes?: Array<ProductType> | null;
    /**
     * 
     * @type {number}
     * @memberof DepartmentWithCountUser
     */
    UserCount?: number;
}
/**
 * 
 * @export
 * @interface DepartmentWithCountUserListResult
 */
export interface DepartmentWithCountUserListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof DepartmentWithCountUserListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DepartmentWithCountUserListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<DepartmentWithCountUser>}
     * @memberof DepartmentWithCountUserListResult
     */
    Data?: Array<DepartmentWithCountUser> | null;
}
/**
 * 
 * @export
 * @interface Document
 */
export interface Document {
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    Description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Document
     */
    FileVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof Document
     */
    Url?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Document
     */
    HasThumb?: boolean;
}
/**
 * 
 * @export
 * @interface DocumentDto
 */
export interface DocumentDto {
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    Description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentDto
     */
    FileVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof DocumentDto
     */
    Url?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDto
     */
    HasThumb?: boolean;
    /**
     * 
     * @type {User}
     * @memberof DocumentDto
     */
    CreateBy?: User;
    /**
     * 
     * @type {DocumentFromEnum}
     * @memberof DocumentDto
     */
    DocumentFrom?: DocumentFromEnum;
}
/**
 * 
 * @export
 * @interface DocumentDtoListResult
 */
export interface DocumentDtoListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentDtoListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentDtoListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<DocumentDto>}
     * @memberof DocumentDtoListResult
     */
    Data?: Array<DocumentDto> | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum DocumentFromEnum {
    Document = 'Document',
    Test = 'Test',
    Message = 'Message'
}

/**
 * 
 * @export
 * @interface DocumentListResult
 */
export interface DocumentListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof DocumentListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Document>}
     * @memberof DocumentListResult
     */
    Data?: Array<Document> | null;
}
/**
 * 
 * @export
 * @interface EditMatrixItemModuleCommand
 */
export interface EditMatrixItemModuleCommand {
    /**
     * 
     * @type {number}
     * @memberof EditMatrixItemModuleCommand
     */
    MatrixItemModuleId: number;
    /**
     * 
     * @type {string}
     * @memberof EditMatrixItemModuleCommand
     */
    Deadline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditMatrixItemModuleCommand
     */
    Description?: string | null;
}
/**
 * 
 * @export
 * @interface EditSallingGroupUserCommand
 */
export interface EditSallingGroupUserCommand {
    /**
     * 
     * @type {number}
     * @memberof EditSallingGroupUserCommand
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof EditSallingGroupUserCommand
     */
    FullName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EditSallingGroupUserCommand
     */
    IsAdmin?: boolean;
    /**
     * 
     * @type {StatesEnum}
     * @memberof EditSallingGroupUserCommand
     */
    State?: StatesEnum;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof EditSallingGroupUserCommand
     */
    ManagedVendors?: Array<Vendor> | null;
    /**
     * 
     * @type {string}
     * @memberof EditSallingGroupUserCommand
     */
    Modules?: string | null;
}
/**
 * 
 * @export
 * @interface EditSystemConfigCommand
 */
export interface EditSystemConfigCommand {
    /**
     * 
     * @type {number}
     * @memberof EditSystemConfigCommand
     */
    WarningOverdueDays?: number;
    /**
     * 
     * @type {OverdueNotificationEnum}
     * @memberof EditSystemConfigCommand
     */
    OverdueNotification?: OverdueNotificationEnum;
    /**
     * 
     * @type {ModuleFollowTestApprovedEnum}
     * @memberof EditSystemConfigCommand
     */
    ModuleFollowTestApproved?: ModuleFollowTestApprovedEnum;
}
/**
 * 
 * @export
 * @interface EditUserCommand
 */
export interface EditUserCommand {
    /**
     * 
     * @type {string}
     * @memberof EditUserCommand
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EditUserCommand
     */
    FullName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EditUserCommand
     */
    Id?: number;
}
/**
 * 
 * @export
 * @interface EditUserVendorCommand
 */
export interface EditUserVendorCommand {
    /**
     * 
     * @type {number}
     * @memberof EditUserVendorCommand
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof EditUserVendorCommand
     */
    FullName?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof EditUserVendorCommand
     */
    State?: StatesEnum;
    /**
     * 
     * @type {string}
     * @memberof EditUserVendorCommand
     */
    Modules?: string | null;
}
/**
 * 
 * @export
 * @interface ExportMatrixItemToExcelQuery
 */
export interface ExportMatrixItemToExcelQuery {
    /**
     * 
     * @type {number}
     * @memberof ExportMatrixItemToExcelQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof ExportMatrixItemToExcelQuery
     */
    VendorId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExportMatrixItemToExcelQuery
     */
    ReponsiveUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ExportMatrixItemToExcelQuery
     */
    Year?: number;
    /**
     * 
     * @type {Array<SearchTypeItem>}
     * @memberof ExportMatrixItemToExcelQuery
     */
    FilterItems?: Array<SearchTypeItem> | null;
    /**
     * 
     * @type {MatrixItemStatusQueryEnum}
     * @memberof ExportMatrixItemToExcelQuery
     */
    Status?: MatrixItemStatusQueryEnum;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof ExportMatrixItemToExcelQuery
     */
    OrderBy?: Array<OrderBy> | null;
}
/**
 * 
 * @export
 * @interface GetPagedBrandsQuery
 */
export interface GetPagedBrandsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedBrandsQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedBrandsQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedBrandsQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedBrandsQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedBrandsQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedBrandsQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedCategorysQuery
 */
export interface GetPagedCategorysQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedCategorysQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedCategorysQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedCategorysQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedCategorysQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedCategorysQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedCategorysQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedComponentsQuery
 */
export interface GetPagedComponentsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedComponentsQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedComponentsQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedComponentsQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedComponentsQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedComponentsQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedComponentsQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedDepartmentsQuery
 */
export interface GetPagedDepartmentsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedDepartmentsQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedDepartmentsQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedDepartmentsQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedDepartmentsQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedDepartmentsQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedMatrixItemQuery
 */
export interface GetPagedMatrixItemQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedMatrixItemQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedMatrixItemQuery
     */
    VendorId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedMatrixItemQuery
     */
    ReponsiveUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedMatrixItemQuery
     */
    Year?: number;
    /**
     * 
     * @type {Array<SearchTypeItem>}
     * @memberof GetPagedMatrixItemQuery
     */
    FilterItems?: Array<SearchTypeItem> | null;
    /**
     * 
     * @type {MatrixItemStatusQueryEnum}
     * @memberof GetPagedMatrixItemQuery
     */
    Status?: MatrixItemStatusQueryEnum;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedMatrixItemQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedMatrixItemQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedMatrixItemQuery
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface GetPagedModuleMessagesQuery
 */
export interface GetPagedModuleMessagesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedModuleMessagesQuery
     */
    MatrixModuleItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedModuleMessagesQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedModuleMessagesQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedModuleMessagesQuery
     */
    SearchString?: string | null;
}
/**
 * 
 * @export
 * @interface GetPagedModulesQuery
 */
export interface GetPagedModulesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedModulesQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedModulesQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedModulesQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedModulesQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedModulesQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ModuleTypeQueryEnum}
     * @memberof GetPagedModulesQuery
     */
    ModuleType?: ModuleTypeQueryEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPagedModulesQuery
     */
    ComponentId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedModulesQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedNotificationQuery
 */
export interface GetPagedNotificationQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedNotificationQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedNotificationQuery
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface GetPagedProductTypesQuery
 */
export interface GetPagedProductTypesQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductTypesQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductTypesQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedProductTypesQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedProductTypesQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedProductTypesQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedProductsQuery
 */
export interface GetPagedProductsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    Page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedProductsQuery
     */
    Search?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetPagedProductsQuery
     */
    SortField?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedProductsQuery
     */
    IsDescending?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedProductsQuery
     */
    GetOnlyActive?: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    BrandId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    VendorId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    CategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsQuery
     */
    Year?: number;
}
/**
 * 
 * @export
 * @interface GetPagedProductsToAddMatrixQuery
 */
export interface GetPagedProductsToAddMatrixQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    MatrixYear?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    BrandId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    CategoryId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    VendorId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    Year?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedProductsToAddMatrixQuery
     */
    IsNewProductonly?: boolean;
}
/**
 * 
 * @export
 * @interface GetPagedTestsQuery
 */
export interface GetPagedTestsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedTestsQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedTestsQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedTestsQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedTestsQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedTestsQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedTestsQuery
     */
    VendorId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedTestsQuery
     */
    ComponentId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedTestsQuery
     */
    GetOnlyActive?: boolean;
    /**
     * 
     * @type {TestStatusQueryEnum}
     * @memberof GetPagedTestsQuery
     */
    Status?: TestStatusQueryEnum;
    /**
     * 
     * @type {number}
     * @memberof GetPagedTestsQuery
     */
    CModelId?: number;
}
/**
 * 
 * @export
 * @interface GetPagedUserQuery
 */
export interface GetPagedUserQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedUserQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedUserQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedUserQuery
     */
    VendorId?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedUserQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedUserQuery
     */
    OrderBy?: Array<OrderBy> | null;
}
/**
 * 
 * @export
 * @interface GetPagedVendorsQuery
 */
export interface GetPagedVendorsQuery {
    /**
     * 
     * @type {number}
     * @memberof GetPagedVendorsQuery
     */
    PageNumber?: number;
    /**
     * 
     * @type {number}
     * @memberof GetPagedVendorsQuery
     */
    PageSize?: number;
    /**
     * 
     * @type {string}
     * @memberof GetPagedVendorsQuery
     */
    SearchString?: string | null;
    /**
     * 
     * @type {Array<OrderBy>}
     * @memberof GetPagedVendorsQuery
     */
    OrderBy?: Array<OrderBy> | null;
    /**
     * 
     * @type {number}
     * @memberof GetPagedVendorsQuery
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPagedVendorsQuery
     */
    GetOnlyActive?: boolean;
}
/**
 * 
 * @export
 * @interface GetProductsCanBeAssignToTestQuery
 */
export interface GetProductsCanBeAssignToTestQuery {
    /**
     * 
     * @type {number}
     * @memberof GetProductsCanBeAssignToTestQuery
     */
    TestId?: number;
    /**
     * 
     * @type {number}
     * @memberof GetProductsCanBeAssignToTestQuery
     */
    BrandId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsCanBeAssignToTestQuery
     */
    CategoryId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsCanBeAssignToTestQuery
     */
    VendorId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetProductsCanBeAssignToTestQuery
     */
    Year?: number | null;
}
/**
 * 
 * @export
 * @interface IResult
 */
export interface IResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof IResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof IResult
     */
    Succeeded?: boolean;
}
/**
 * 
 * @export
 * @interface ImportExcelResponse
 */
export interface ImportExcelResponse {
    /**
     * 
     * @type {number}
     * @memberof ImportExcelResponse
     */
    TotalItemImportSuccess?: number;
    /**
     * 
     * @type {number}
     * @memberof ImportExcelResponse
     */
    TotalItemImportFail?: number;
    /**
     * 
     * @type {Array<ProductImport>}
     * @memberof ImportExcelResponse
     */
    ProductImports?: Array<ProductImport> | null;
}
/**
 * 
 * @export
 * @interface Int32ApiResponse
 */
export interface Int32ApiResponse {
    /**
     * 
     * @type {number}
     * @memberof Int32ApiResponse
     */
    Data?: number;
    /**
     * 
     * @type {string}
     * @memberof Int32ApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Int32ApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof Int32ApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface Int32Result
 */
export interface Int32Result {
    /**
     * 
     * @type {Array<string>}
     * @memberof Int32Result
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof Int32Result
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Int32Result
     */
    Data?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum LanguageEnum {
    En = 'En',
    Da = 'Da'
}

/**
 * 
 * @export
 * @interface LoginFromAzureRequest
 */
export interface LoginFromAzureRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginFromAzureRequest
     */
    Token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginFromAzureRequest
     */
    DeviceToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LoginFromAzureRequest
     */
    UdId?: string | null;
}
/**
 * 
 * @export
 * @interface MaskNotisIsReadCommand
 */
export interface MaskNotisIsReadCommand {
    /**
     * 
     * @type {Array<number>}
     * @memberof MaskNotisIsReadCommand
     */
    NotiIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface Matrix
 */
export interface Matrix {
    /**
     * 
     * @type {number}
     * @memberof Matrix
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof Matrix
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Matrix
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof Matrix
     */
    Year?: number;
    /**
     * 
     * @type {boolean}
     * @memberof Matrix
     */
    IsLocked?: boolean;
}
/**
 * 
 * @export
 * @interface MatrixGeneralModuleDetail
 */
export interface MatrixGeneralModuleDetail {
    /**
     * 
     * @type {number}
     * @memberof MatrixGeneralModuleDetail
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixGeneralModuleDetail
     */
    ModuleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixGeneralModuleDetail
     */
    Type?: string | null;
    /**
     * 
     * @type {MatrixItemStatusEnum}
     * @memberof MatrixGeneralModuleDetail
     */
    Status?: MatrixItemStatusEnum;
    /**
     * 
     * @type {User}
     * @memberof MatrixGeneralModuleDetail
     */
    ReponsiveUser?: User;
    /**
     * 
     * @type {string}
     * @memberof MatrixGeneralModuleDetail
     */
    Deadline?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixGeneralModuleDetail
     */
    CanAccess?: boolean;
}
/**
 * 
 * @export
 * @interface MatrixItem
 */
export interface MatrixItem {
    /**
     * 
     * @type {number}
     * @memberof MatrixItem
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItem
     */
    ProductId?: number;
    /**
     * 
     * @type {Product}
     * @memberof MatrixItem
     */
    Product?: Product;
    /**
     * 
     * @type {number}
     * @memberof MatrixItem
     */
    MatrixId?: number;
    /**
     * 
     * @type {Matrix}
     * @memberof MatrixItem
     */
    Matrix?: Matrix;
    /**
     * 
     * @type {Array<MatrixItemModule>}
     * @memberof MatrixItem
     */
    MatrixItemModules?: Array<MatrixItemModule> | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof MatrixItem
     */
    States?: StatesEnum;
}
/**
 * 
 * @export
 * @interface MatrixItemDto
 */
export interface MatrixItemDto {
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDto
     */
    MatrixItemId?: number;
    /**
     * 
     * @type {Product}
     * @memberof MatrixItemDto
     */
    Product?: Product;
    /**
     * 
     * @type {{ [key: string]: MatrixModuleStatusDto; }}
     * @memberof MatrixItemDto
     */
    ModuleStatus?: { [key: string]: MatrixModuleStatusDto; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemDto
     */
    HaveSpecification?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDto
     */
    TotalModuleApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDto
     */
    TotalModule?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDto
     */
    LastUpdated?: number;
}
/**
 * 
 * @export
 * @interface MatrixItemDtoPaginatedResult
 */
export interface MatrixItemDtoPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemDtoPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemDtoPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<MatrixItemDto>}
     * @memberof MatrixItemDtoPaginatedResult
     */
    Data?: Array<MatrixItemDto> | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDtoPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDtoPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDtoPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemDtoPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface MatrixItemGeneral
 */
export interface MatrixItemGeneral {
    /**
     * 
     * @type {number}
     * @memberof MatrixItemGeneral
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemGeneral
     */
    TotalModuleApproved?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemGeneral
     */
    TotalModule?: number;
    /**
     * 
     * @type {User}
     * @memberof MatrixItemGeneral
     */
    CreateByUser?: User;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemGeneral
     */
    CreatedOn?: string;
    /**
     * 
     * @type {User}
     * @memberof MatrixItemGeneral
     */
    LastModifiedByUser?: User;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemGeneral
     */
    LastModifiedOn?: string;
    /**
     * 
     * @type {Array<UserSallingGroup>}
     * @memberof MatrixItemGeneral
     */
    ManagedBy?: Array<UserSallingGroup> | null;
    /**
     * 
     * @type {Product}
     * @memberof MatrixItemGeneral
     */
    Product?: Product;
    /**
     * 
     * @type {Array<MatrixGeneralModuleDetail>}
     * @memberof MatrixItemGeneral
     */
    ModuleDetails?: Array<MatrixGeneralModuleDetail> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemGeneral
     */
    IsLocked?: boolean;
    /**
     * 
     * @type {Array<ProductSpecificationResponseModel>}
     * @memberof MatrixItemGeneral
     */
    Specifications?: Array<ProductSpecificationResponseModel> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemGeneralResult
 */
export interface MatrixItemGeneralResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemGeneralResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemGeneralResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {MatrixItemGeneral}
     * @memberof MatrixItemGeneralResult
     */
    Data?: MatrixItemGeneral;
}
/**
 * 
 * @export
 * @interface MatrixItemListResult
 */
export interface MatrixItemListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<MatrixItem>}
     * @memberof MatrixItemListResult
     */
    Data?: Array<MatrixItem> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModule
 */
export interface MatrixItemModule {
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModule
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModule
     */
    MatrixItemId?: number;
    /**
     * 
     * @type {MatrixItem}
     * @memberof MatrixItemModule
     */
    MatrixItem?: MatrixItem;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModule
     */
    ModuleId?: number;
    /**
     * 
     * @type {Module}
     * @memberof MatrixItemModule
     */
    Module?: Module;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModule
     */
    ReponsiveUserId?: number | null;
    /**
     * 
     * @type {User}
     * @memberof MatrixItemModule
     */
    ReponsiveUser?: User;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModule
     */
    Deadline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModule
     */
    Description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModule
     */
    IsApproved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModule
     */
    ApprovedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModule
     */
    ApprovedOn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModule
     */
    IsInProcess?: boolean;
    /**
     * 
     * @type {Array<Message>}
     * @memberof MatrixItemModule
     */
    Messages?: Array<Message> | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof MatrixItemModule
     */
    Documents?: Array<Document> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleCanBeAdd
 */
export interface MatrixItemModuleCanBeAdd {
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleCanBeAdd
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleCanBeAdd
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleCanBeAdd
     */
    Description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleCanBeAdd
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof MatrixItemModuleCanBeAdd
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {ModuleTypeEnum}
     * @memberof MatrixItemModuleCanBeAdd
     */
    ModuleType?: ModuleTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleCanBeAdd
     */
    ComponentId?: number | null;
    /**
     * 
     * @type {Component}
     * @memberof MatrixItemModuleCanBeAdd
     */
    Component?: Component;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleCanBeAdd
     */
    DefaultDeadlineDay?: number;
    /**
     * 
     * @type {StatesEnum}
     * @memberof MatrixItemModuleCanBeAdd
     */
    States?: StatesEnum;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleCanBeAdd
     */
    Order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleCanBeAdd
     */
    IsAdded?: boolean;
    /**
     * 
     * @type {MatrixItemModule}
     * @memberof MatrixItemModuleCanBeAdd
     */
    MatrixItemModule?: MatrixItemModule;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleCanBeAdd
     */
    DeadlineDate?: string | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleCanBeAddListResult
 */
export interface MatrixItemModuleCanBeAddListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemModuleCanBeAddListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleCanBeAddListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<MatrixItemModuleCanBeAdd>}
     * @memberof MatrixItemModuleCanBeAddListResult
     */
    Data?: Array<MatrixItemModuleCanBeAdd> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleDto
 */
export interface MatrixItemModuleDto {
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleDto
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleDto
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    MatrixItemId?: number;
    /**
     * 
     * @type {MatrixItem}
     * @memberof MatrixItemModuleDto
     */
    MatrixItem?: MatrixItem;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    ModuleId?: number;
    /**
     * 
     * @type {Module}
     * @memberof MatrixItemModuleDto
     */
    Module?: Module;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    ReponsiveUserId?: number | null;
    /**
     * 
     * @type {User}
     * @memberof MatrixItemModuleDto
     */
    ReponsiveUser?: User;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleDto
     */
    Deadline?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleDto
     */
    Description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleDto
     */
    IsApproved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MatrixItemModuleDto
     */
    ApprovedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleDto
     */
    ApprovedOn?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleDto
     */
    IsInProcess?: boolean;
    /**
     * 
     * @type {Array<Message>}
     * @memberof MatrixItemModuleDto
     */
    Messages?: Array<Message> | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof MatrixItemModuleDto
     */
    Documents?: Array<Document> | null;
    /**
     * 
     * @type {User}
     * @memberof MatrixItemModuleDto
     */
    LastUpdated?: User;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof MatrixItemModuleDto
     */
    Vendors?: Array<Vendor> | null;
    /**
     * 
     * @type {MatrixItemStatusEnum}
     * @memberof MatrixItemModuleDto
     */
    Status?: MatrixItemStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof MatrixItemModuleDto
     */
    ComponentModelName?: string | null;
    /**
     * 
     * @type {ProductSpecificationResponseModel}
     * @memberof MatrixItemModuleDto
     */
    Specification?: ProductSpecificationResponseModel;
    /**
     * 
     * @type {Array<Test>}
     * @memberof MatrixItemModuleDto
     */
    Tests?: Array<Test> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleDtoResult
 */
export interface MatrixItemModuleDtoResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemModuleDtoResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleDtoResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {MatrixItemModuleDto}
     * @memberof MatrixItemModuleDtoResult
     */
    Data?: MatrixItemModuleDto;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleListResult
 */
export interface MatrixItemModuleListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemModuleListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<MatrixItemModule>}
     * @memberof MatrixItemModuleListResult
     */
    Data?: Array<MatrixItemModule> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleResponsive
 */
export interface MatrixItemModuleResponsive {
    /**
     * 
     * @type {Array<Module>}
     * @memberof MatrixItemModuleResponsive
     */
    Modules?: Array<Module> | null;
    /**
     * 
     * @type {Array<ModuleUserReponsive>}
     * @memberof MatrixItemModuleResponsive
     */
    ModuleUserReponsives?: Array<ModuleUserReponsive> | null;
}
/**
 * 
 * @export
 * @interface MatrixItemModuleResponsiveResult
 */
export interface MatrixItemModuleResponsiveResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixItemModuleResponsiveResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixItemModuleResponsiveResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {MatrixItemModuleResponsive}
     * @memberof MatrixItemModuleResponsiveResult
     */
    Data?: MatrixItemModuleResponsive;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum MatrixItemSearchTypeEnum {
    ProductName = 'ProductName',
    ArticleNumber = 'ArticleNumber',
    Gtin = 'GTIN'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum MatrixItemStatusEnum {
    Null = 'Null',
    OnGoing = 'OnGoing',
    InProcess = 'InProcess',
    OverDue = 'OverDue',
    Approved = 'Approved'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum MatrixItemStatusQueryEnum {
    All = 'All',
    OnGoing = 'OnGoing',
    InProcess = 'InProcess',
    OverDue = 'OverDue',
    Approved = 'Approved'
}

/**
 * 
 * @export
 * @interface MatrixModuleStatusDto
 */
export interface MatrixModuleStatusDto {
    /**
     * 
     * @type {MatrixItemStatusEnum}
     * @memberof MatrixModuleStatusDto
     */
    Status?: MatrixItemStatusEnum;
    /**
     * 
     * @type {User}
     * @memberof MatrixModuleStatusDto
     */
    ReponsiveUser?: User;
}
/**
 * 
 * @export
 * @interface MatrixResult
 */
export interface MatrixResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Matrix}
     * @memberof MatrixResult
     */
    Data?: Matrix;
}
/**
 * 
 * @export
 * @interface Message
 */
export interface Message {
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Message
     */
    ParentId?: number | null;
    /**
     * 
     * @type {Message}
     * @memberof Message
     */
    Parent?: Message;
    /**
     * 
     * @type {Array<Message>}
     * @memberof Message
     */
    Childrens?: Array<Message> | null;
    /**
     * 
     * @type {string}
     * @memberof Message
     */
    Text?: string | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof Message
     */
    Documents?: Array<Document> | null;
}
/**
 * 
 * @export
 * @interface MessageDto
 */
export interface MessageDto {
    /**
     * 
     * @type {number}
     * @memberof MessageDto
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageDto
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof MessageDto
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MessageDto
     */
    ParentId?: number | null;
    /**
     * 
     * @type {Message}
     * @memberof MessageDto
     */
    Parent?: Message;
    /**
     * 
     * @type {Array<Message>}
     * @memberof MessageDto
     */
    Childrens?: Array<Message> | null;
    /**
     * 
     * @type {string}
     * @memberof MessageDto
     */
    Text?: string | null;
    /**
     * 
     * @type {Array<Document>}
     * @memberof MessageDto
     */
    Documents?: Array<Document> | null;
    /**
     * 
     * @type {User}
     * @memberof MessageDto
     */
    UserCreated?: User;
}
/**
 * 
 * @export
 * @interface MessageDtoPaginatedResult
 */
export interface MessageDtoPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageDtoPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageDtoPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<MessageDto>}
     * @memberof MessageDtoPaginatedResult
     */
    Data?: Array<MessageDto> | null;
    /**
     * 
     * @type {number}
     * @memberof MessageDtoPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageDtoPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageDtoPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof MessageDtoPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface MessageResult
 */
export interface MessageResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MessageResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessageResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Message}
     * @memberof MessageResult
     */
    Data?: Message;
}
/**
 * 
 * @export
 * @interface MessagesWithUser
 */
export interface MessagesWithUser {
    /**
     * 
     * @type {Array<Message>}
     * @memberof MessagesWithUser
     */
    Messages?: Array<Message> | null;
    /**
     * 
     * @type {Array<User>}
     * @memberof MessagesWithUser
     */
    Users?: Array<User> | null;
}
/**
 * 
 * @export
 * @interface MessagesWithUserResult
 */
export interface MessagesWithUserResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof MessagesWithUserResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof MessagesWithUserResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {MessagesWithUser}
     * @memberof MessagesWithUserResult
     */
    Data?: MessagesWithUser;
}
/**
 * 
 * @export
 * @interface Module
 */
export interface Module {
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Module
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Module
     */
    Description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Module
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {ModuleTypeEnum}
     * @memberof Module
     */
    ModuleType?: ModuleTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    ComponentId?: number | null;
    /**
     * 
     * @type {Component}
     * @memberof Module
     */
    Component?: Component;
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    DefaultDeadlineDay?: number;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Module
     */
    States?: StatesEnum;
    /**
     * 
     * @type {number}
     * @memberof Module
     */
    Order?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ModuleFollowTestApprovedEnum {
    NotApplicable = 'NotApplicable',
    Follow = 'Follow'
}

/**
 * 
 * @export
 * @interface ModuleIdAndDeadline
 */
export interface ModuleIdAndDeadline {
    /**
     * 
     * @type {number}
     * @memberof ModuleIdAndDeadline
     */
    ModuleId?: number;
    /**
     * 
     * @type {string}
     * @memberof ModuleIdAndDeadline
     */
    Deadline?: string | null;
}
/**
 * 
 * @export
 * @interface ModuleListResult
 */
export interface ModuleListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Module>}
     * @memberof ModuleListResult
     */
    Data?: Array<Module> | null;
}
/**
 * 
 * @export
 * @interface ModulePaginatedResult
 */
export interface ModulePaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModulePaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ModulePaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Module>}
     * @memberof ModulePaginatedResult
     */
    Data?: Array<Module> | null;
    /**
     * 
     * @type {number}
     * @memberof ModulePaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ModulePaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ModulePaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ModulePaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface ModuleResult
 */
export interface ModuleResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ModuleResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ModuleResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Module}
     * @memberof ModuleResult
     */
    Data?: Module;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum ModuleTypeEnum {
    Product = 'Product',
    Component = 'Component'
}

/**
 * 
 * @export
 * @enum {string}
 */

export enum ModuleTypeQueryEnum {
    All = 'All',
    Product = 'Product',
    Component = 'Component'
}

/**
 * 
 * @export
 * @interface ModuleUserReponsive
 */
export interface ModuleUserReponsive {
    /**
     * 
     * @type {number}
     * @memberof ModuleUserReponsive
     */
    ModuleId?: number;
    /**
     * 
     * @type {number}
     * @memberof ModuleUserReponsive
     */
    ReponsiveUserId?: number | null;
}
/**
 * 
 * @export
 * @interface Notification
 */
export interface Notification {
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    Id?: number;
    /**
     * 
     * @type {NotificationTypeEnum}
     * @memberof Notification
     */
    NotificationType?: NotificationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    Content?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    DanishContent?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Notification
     */
    Link?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    NotiToUserId?: number;
    /**
     * 
     * @type {User}
     * @memberof Notification
     */
    NotiToUser?: User;
    /**
     * 
     * @type {boolean}
     * @memberof Notification
     */
    IsRead?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    MatrixItemId?: number | null;
    /**
     * 
     * @type {MatrixItem}
     * @memberof Notification
     */
    MatrixItem?: MatrixItem;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    MatrixItemModuleId?: number | null;
    /**
     * 
     * @type {MatrixItemModule}
     * @memberof Notification
     */
    MatrixItemModule?: MatrixItemModule;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    TestId?: number | null;
    /**
     * 
     * @type {Test}
     * @memberof Notification
     */
    Test?: Test;
    /**
     * 
     * @type {number}
     * @memberof Notification
     */
    VendorId?: number | null;
}
/**
 * 
 * @export
 * @interface NotificationDto
 */
export interface NotificationDto {
    /**
     * 
     * @type {Notification}
     * @memberof NotificationDto
     */
    Notification?: Notification;
    /**
     * 
     * @type {User}
     * @memberof NotificationDto
     */
    UserCreated?: User;
    /**
     * 
     * @type {string}
     * @memberof NotificationDto
     */
    DateCreated?: string;
}
/**
 * 
 * @export
 * @interface NotificationDtoPaginatedResult
 */
export interface NotificationDtoPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationDtoPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof NotificationDtoPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<NotificationDto>}
     * @memberof NotificationDtoPaginatedResult
     */
    Data?: Array<NotificationDto> | null;
    /**
     * 
     * @type {number}
     * @memberof NotificationDtoPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationDtoPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationDtoPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof NotificationDtoPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum NotificationTypeEnum {
    SgUserAddProductToMatrix = 'SgUserAddProductToMatrix',
    RemoveProductFromMatrix = 'RemoveProductFromMatrix',
    ApproveModule = 'ApproveModule',
    UnApproveModule = 'UnApproveModule',
    DeleteModule = 'DeleteModule',
    AddModule = 'AddModule',
    UpdateModuleDeadline = 'UpdateModuleDeadline',
    AddDocumentToModule = 'AddDocumentToModule',
    AddCommentToModule = 'AddCommentToModule',
    AddTestToModule = 'AddTestToModule',
    RemoveTestFromModule = 'RemoveTestFromModule',
    ApproveTest = 'ApproveTest',
    UnApproveTest = 'UnApproveTest',
    NotificationBeforeModuleDeadLine = 'NotificationBeforeModuleDeadLine',
    NotificationInModuleDeadline = 'NotificationInModuleDeadline'
}

/**
 * 
 * @export
 * @interface OrderBy
 */
export interface OrderBy {
    /**
     * 
     * @type {string}
     * @memberof OrderBy
     */
    ColumnName?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof OrderBy
     */
    IsDesc?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum OverdueNotificationEnum {
    PushNotificationAndSendEmail = 'PushNotificationAndSendEmail',
    PushNotification = 'PushNotification',
    SendEmail = 'SendEmail',
    DoNotApply = 'DoNotApply'
}

/**
 * 
 * @export
 * @interface PermissionRequest
 */
export interface PermissionRequest {
    /**
     * 
     * @type {string}
     * @memberof PermissionRequest
     */
    RoleId?: string | null;
    /**
     * 
     * @type {Array<RoleClaimRequest>}
     * @memberof PermissionRequest
     */
    RoleClaims?: Array<RoleClaimRequest> | null;
}
/**
 * 
 * @export
 * @interface PermissionResponse
 */
export interface PermissionResponse {
    /**
     * 
     * @type {number}
     * @memberof PermissionResponse
     */
    RoleId?: number;
    /**
     * 
     * @type {string}
     * @memberof PermissionResponse
     */
    RoleName?: string | null;
    /**
     * 
     * @type {Array<RoleClaimResponse>}
     * @memberof PermissionResponse
     */
    RoleClaims?: Array<RoleClaimResponse> | null;
}
/**
 * 
 * @export
 * @interface PermissionResponseResult
 */
export interface PermissionResponseResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof PermissionResponseResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionResponseResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {PermissionResponse}
     * @memberof PermissionResponseResult
     */
    Data?: PermissionResponse;
}
/**
 * 
 * @export
 * @interface Product
 */
export interface Product {
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    GTIN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    Code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Product
     */
    ArticleNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Product
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    CategoryId?: number;
    /**
     * 
     * @type {Category}
     * @memberof Product
     */
    Category?: Category;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    BrandId?: number;
    /**
     * 
     * @type {Brand}
     * @memberof Product
     */
    Brand?: Brand;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    VendorId?: number;
    /**
     * 
     * @type {Vendor}
     * @memberof Product
     */
    Vendor?: Vendor;
    /**
     * 
     * @type {number}
     * @memberof Product
     */
    Year?: number;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Product
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<ProductSpecification>}
     * @memberof Product
     */
    Specifications?: Array<ProductSpecification> | null;
}
/**
 * 
 * @export
 * @interface ProductImport
 */
export interface ProductImport {
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    Code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    GTIN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    ArticleNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    ProductType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    Category?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    Brand?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    Vendor?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    Year?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductImport
     */
    States?: string | null;
}
/**
 * 
 * @export
 * @interface ProductModel
 */
export interface ProductModel {
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    GTIN?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    Code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    ArticleNumber?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    ProductTypeName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    CategoryId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    CategoryName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    BrandId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    BrandName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    VendorId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    VendorName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModel
     */
    Year?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductModel
     */
    Matrixs?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof ProductModel
     */
    States?: StatesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ProductModel
     */
    HaveSpecification?: boolean;
    /**
     * 
     * @type {Array<ProductSpecificationResponseModel>}
     * @memberof ProductModel
     */
    Specifications?: Array<ProductSpecificationResponseModel> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductModel
     */
    ModelIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface ProductModelApiResponse
 */
export interface ProductModelApiResponse {
    /**
     * 
     * @type {ProductModel}
     * @memberof ProductModelApiResponse
     */
    Data?: ProductModel;
    /**
     * 
     * @type {string}
     * @memberof ProductModelApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModelApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductModelApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface ProductModelIEnumerableApiResponse
 */
export interface ProductModelIEnumerableApiResponse {
    /**
     * 
     * @type {Array<ProductModel>}
     * @memberof ProductModelIEnumerableApiResponse
     */
    Data?: Array<ProductModel> | null;
    /**
     * 
     * @type {string}
     * @memberof ProductModelIEnumerableApiResponse
     */
    Error?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductModelIEnumerableApiResponse
     */
    Totals?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductModelIEnumerableApiResponse
     */
    TotalPages?: number;
}
/**
 * 
 * @export
 * @interface ProductPaginatedResult
 */
export interface ProductPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Product>}
     * @memberof ProductPaginatedResult
     */
    Data?: Array<Product> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface ProductSpecification
 */
export interface ProductSpecification {
    /**
     * 
     * @type {number}
     * @memberof ProductSpecification
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecification
     */
    ProductId?: number;
    /**
     * 
     * @type {Product}
     * @memberof ProductSpecification
     */
    Product?: Product;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecification
     */
    ComponentId?: number;
    /**
     * 
     * @type {Component}
     * @memberof ProductSpecification
     */
    Component?: Component;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecification
     */
    CModelId?: number;
    /**
     * 
     * @type {CModel}
     * @memberof ProductSpecification
     */
    CModel?: CModel;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecification
     */
    CBrandId?: number;
    /**
     * 
     * @type {CBrand}
     * @memberof ProductSpecification
     */
    CBrand?: CBrand;
}
/**
 * 
 * @export
 * @interface ProductSpecificationModel
 */
export interface ProductSpecificationModel {
    /**
     * 
     * @type {number}
     * @memberof ProductSpecificationModel
     */
    ProductId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProductSpecificationModel
     */
    ModelIds?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductSpecificationModel
     */
    IsOverride?: boolean;
}
/**
 * 
 * @export
 * @interface ProductSpecificationResponseModel
 */
export interface ProductSpecificationResponseModel {
    /**
     * 
     * @type {number}
     * @memberof ProductSpecificationResponseModel
     */
    ComponentId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductSpecificationResponseModel
     */
    ComponentName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecificationResponseModel
     */
    CBrandId?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductSpecificationResponseModel
     */
    CBrandName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductSpecificationResponseModel
     */
    CModelName?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecificationResponseModel
     */
    CModelId?: number;
    /**
     * 
     * @type {Array<CBrandModel>}
     * @memberof ProductSpecificationResponseModel
     */
    Brands?: Array<CBrandModel> | null;
    /**
     * 
     * @type {Array<CModelModel>}
     * @memberof ProductSpecificationResponseModel
     */
    Models?: Array<CModelModel> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductSpecificationResponseModel
     */
    Tests?: number;
}
/**
 * 
 * @export
 * @interface ProductType
 */
export interface ProductType {
    /**
     * 
     * @type {number}
     * @memberof ProductType
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof ProductType
     */
    Name?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof ProductType
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof ProductType
     */
    Vendors?: Array<Vendor> | null;
    /**
     * 
     * @type {Array<Department>}
     * @memberof ProductType
     */
    Departments?: Array<Department> | null;
}
/**
 * 
 * @export
 * @interface ProductTypePaginatedResult
 */
export interface ProductTypePaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTypePaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTypePaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof ProductTypePaginatedResult
     */
    Data?: Array<ProductType> | null;
    /**
     * 
     * @type {number}
     * @memberof ProductTypePaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTypePaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTypePaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductTypePaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface ProductTypeResult
 */
export interface ProductTypeResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof ProductTypeResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof ProductTypeResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {ProductType}
     * @memberof ProductTypeResult
     */
    Data?: ProductType;
}
/**
 * 
 * @export
 * @interface RegisterUserCommand
 */
export interface RegisterUserCommand {
    /**
     * 
     * @type {string}
     * @memberof RegisterUserCommand
     */
    FullName: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserCommand
     */
    Email: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserCommand
     */
    Password?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserCommand
     */
    ConfirmPassword?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserCommand
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserCommand
     */
    ActivateUser?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserCommand
     */
    AutoConfirmEmail?: boolean;
    /**
     * 
     * @type {LanguageEnum}
     * @memberof RegisterUserCommand
     */
    Language?: LanguageEnum;
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof RegisterUserCommand
     */
    CompanyType?: CompanyTypeEnum;
    /**
     * 
     * @type {Array<number>}
     * @memberof RegisterUserCommand
     */
    VendorIds?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterUserCommand
     */
    IsAdmin?: boolean;
    /**
     * 
     * @type {number}
     * @memberof RegisterUserCommand
     */
    DepartmentId?: number;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof RegisterUserCommand
     */
    ManagedVendors?: Array<Vendor> | null;
    /**
     * 
     * @type {string}
     * @memberof RegisterUserCommand
     */
    Modules?: string | null;
}
/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    Token: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    Password: string;
    /**
     * 
     * @type {string}
     * @memberof ResetPasswordRequest
     */
    ConfirmPassword: string;
}
/**
 * 
 * @export
 * @interface RoleClaimRequest
 */
export interface RoleClaimRequest {
    /**
     * 
     * @type {number}
     * @memberof RoleClaimRequest
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleClaimRequest
     */
    RoleId?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimRequest
     */
    Type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimRequest
     */
    Value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimRequest
     */
    Description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimRequest
     */
    Group?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleClaimRequest
     */
    Selected?: boolean;
}
/**
 * 
 * @export
 * @interface RoleClaimResponse
 */
export interface RoleClaimResponse {
    /**
     * 
     * @type {number}
     * @memberof RoleClaimResponse
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof RoleClaimResponse
     */
    RoleId?: number;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimResponse
     */
    Type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimResponse
     */
    Value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimResponse
     */
    Description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleClaimResponse
     */
    Group?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleClaimResponse
     */
    Selected?: boolean;
}
/**
 * 
 * @export
 * @interface RoleClaimResponseListResult
 */
export interface RoleClaimResponseListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleClaimResponseListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleClaimResponseListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<RoleClaimResponse>}
     * @memberof RoleClaimResponseListResult
     */
    Data?: Array<RoleClaimResponse> | null;
}
/**
 * 
 * @export
 * @interface RoleRequest
 */
export interface RoleRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    Id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    Name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleRequest
     */
    Description?: string | null;
}
/**
 * 
 * @export
 * @interface RoleResponse
 */
export interface RoleResponse {
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    Id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    Name: string;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    Description?: string | null;
}
/**
 * 
 * @export
 * @interface RoleResponseListResult
 */
export interface RoleResponseListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof RoleResponseListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof RoleResponseListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof RoleResponseListResult
     */
    Data?: Array<RoleResponse> | null;
}
/**
 * 
 * @export
 * @interface SearchTypeItem
 */
export interface SearchTypeItem {
    /**
     * 
     * @type {MatrixItemSearchTypeEnum}
     * @memberof SearchTypeItem
     */
    Name?: MatrixItemSearchTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof SearchTypeItem
     */
    Value?: string | null;
}
/**
 * 
 * @export
 * @interface SetLockMatrixLockCommand
 */
export interface SetLockMatrixLockCommand {
    /**
     * 
     * @type {number}
     * @memberof SetLockMatrixLockCommand
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {number}
     * @memberof SetLockMatrixLockCommand
     */
    MatrixYear?: number;
    /**
     * 
     * @type {boolean}
     * @memberof SetLockMatrixLockCommand
     */
    IsLocked?: boolean;
}
/**
 * 
 * @export
 * @interface SetStatesUserCommand
 */
export interface SetStatesUserCommand {
    /**
     * 
     * @type {number}
     * @memberof SetStatesUserCommand
     */
    Id?: number;
    /**
     * 
     * @type {StatesEnum}
     * @memberof SetStatesUserCommand
     */
    States: StatesEnum;
}
/**
 * 
 * @export
 * @interface SgUserDto
 */
export interface SgUserDto {
    /**
     * 
     * @type {UserSallingGroup}
     * @memberof SgUserDto
     */
    UserSallingGroup?: UserSallingGroup;
    /**
     * 
     * @type {boolean}
     * @memberof SgUserDto
     */
    IsAdmin?: boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum StatesEnum {
    Active = 'Active',
    Inactive = 'Inactive',
    Delete = 'Delete'
}

/**
 * 
 * @export
 * @interface StringIResult
 */
export interface StringIResult {
    /**
     * 
     * @type {string}
     * @memberof StringIResult
     */
    Data?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StringIResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringIResult
     */
    Succeeded?: boolean;
}
/**
 * 
 * @export
 * @interface StringResult
 */
export interface StringResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof StringResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {string}
     * @memberof StringResult
     */
    Data?: string | null;
}
/**
 * 
 * @export
 * @interface SystemConfig
 */
export interface SystemConfig {
    /**
     * 
     * @type {number}
     * @memberof SystemConfig
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof SystemConfig
     */
    Name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SystemConfig
     */
    WarningOverdueDays?: number;
    /**
     * 
     * @type {OverdueNotificationEnum}
     * @memberof SystemConfig
     */
    OverdueNotification?: OverdueNotificationEnum;
    /**
     * 
     * @type {ModuleFollowTestApprovedEnum}
     * @memberof SystemConfig
     */
    ModuleFollowTestApproved?: ModuleFollowTestApprovedEnum;
    /**
     * 
     * @type {StatesEnum}
     * @memberof SystemConfig
     */
    States?: StatesEnum;
}
/**
 * 
 * @export
 * @interface SystemConfigResult
 */
export interface SystemConfigResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof SystemConfigResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SystemConfigResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {SystemConfig}
     * @memberof SystemConfigResult
     */
    Data?: SystemConfig;
}
/**
 * 
 * @export
 * @interface Test
 */
export interface Test {
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    Name?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Test
     */
    States?: StatesEnum;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    Description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof Test
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    VendorId?: number;
    /**
     * 
     * @type {Vendor}
     * @memberof Test
     */
    Vendor?: Vendor;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    ComponentId?: number;
    /**
     * 
     * @type {Component}
     * @memberof Test
     */
    Component?: Component;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    CModelId?: number | null;
    /**
     * 
     * @type {CModel}
     * @memberof Test
     */
    ComponentModel?: CModel;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    TestDate?: string;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    ExpiredDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Test
     */
    IsApproved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Test
     */
    ApprovedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Test
     */
    ApprovedOn?: string;
    /**
     * 
     * @type {Array<Document>}
     * @memberof Test
     */
    Documents?: Array<Document> | null;
}
/**
 * 
 * @export
 * @interface TestDto
 */
export interface TestDto {
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    CreatedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    CreatedOn?: string;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    LastModifiedBy?: number;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    LastModifiedOn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    Name?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof TestDto
     */
    States?: StatesEnum;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    Description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    ProductTypeId?: number;
    /**
     * 
     * @type {ProductType}
     * @memberof TestDto
     */
    ProductType?: ProductType;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    VendorId?: number;
    /**
     * 
     * @type {Vendor}
     * @memberof TestDto
     */
    Vendor?: Vendor;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    ComponentId?: number;
    /**
     * 
     * @type {Component}
     * @memberof TestDto
     */
    Component?: Component;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    CModelId?: number | null;
    /**
     * 
     * @type {CModel}
     * @memberof TestDto
     */
    ComponentModel?: CModel;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    TestDate?: string;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    ExpiredDate?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TestDto
     */
    IsApproved?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TestDto
     */
    ApprovedById?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TestDto
     */
    ApprovedOn?: string;
    /**
     * 
     * @type {Array<Document>}
     * @memberof TestDto
     */
    Documents?: Array<Document> | null;
    /**
     * 
     * @type {User}
     * @memberof TestDto
     */
    CreateBy?: User;
    /**
     * 
     * @type {User}
     * @memberof TestDto
     */
    LastUpdateBy?: User;
    /**
     * 
     * @type {User}
     * @memberof TestDto
     */
    ApprovedBy?: User;
}
/**
 * 
 * @export
 * @interface TestDtoResult
 */
export interface TestDtoResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof TestDtoResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TestDtoResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {TestDto}
     * @memberof TestDtoResult
     */
    Data?: TestDto;
}
/**
 * 
 * @export
 * @interface TestPaginatedResult
 */
export interface TestPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof TestPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TestPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Test>}
     * @memberof TestPaginatedResult
     */
    Data?: Array<Test> | null;
    /**
     * 
     * @type {number}
     * @memberof TestPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof TestPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export enum TestStatusQueryEnum {
    All = 'All',
    OnGoing = 'OnGoing',
    Approved = 'Approved'
}

/**
 * 
 * @export
 * @interface ToggleUserStatusRequest
 */
export interface ToggleUserStatusRequest {
    /**
     * 
     * @type {boolean}
     * @memberof ToggleUserStatusRequest
     */
    ActivateUser?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ToggleUserStatusRequest
     */
    UserId?: number;
}
/**
 * 
 * @export
 * @interface TokenRequest
 */
export interface TokenRequest {
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    Email: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    Password: string;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    DeviceToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenRequest
     */
    UdId?: string | null;
}
/**
 * 
 * @export
 * @interface TokenResponse
 */
export interface TokenResponse {
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    Token?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    RefreshToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    UserImageURL?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    RefreshTokenExpiryTime?: string;
    /**
     * 
     * @type {string}
     * @memberof TokenResponse
     */
    CurrentVendor?: string | null;
}
/**
 * 
 * @export
 * @interface TokenResponseResult
 */
export interface TokenResponseResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof TokenResponseResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TokenResponseResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {TokenResponse}
     * @memberof TokenResponseResult
     */
    Data?: TokenResponse;
}
/**
 * 
 * @export
 * @interface UpdateProfileRequest
 */
export interface UpdateProfileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    FullName: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateProfileRequest
     */
    Email?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateUserRolesRequest
 */
export interface UpdateUserRolesRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateUserRolesRequest
     */
    UserId?: number;
    /**
     * 
     * @type {Array<UserRoleModel>}
     * @memberof UpdateUserRolesRequest
     */
    UserRoles?: Array<UserRoleModel> | null;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {number}
     * @memberof User
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    UserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    NormalizedUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    Email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    NormalizedEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    EmailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    PasswordHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    SecurityStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ConcurrencyStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    PhoneNumberConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    TwoFactorEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    LockoutEnd?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    LockoutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    AccessFailedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    FullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    ProfilePictureDataUrl?: string | null;
    /**
     * 
     * @type {LanguageEnum}
     * @memberof User
     */
    Language?: LanguageEnum;
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof User
     */
    CompanyType?: CompanyTypeEnum;
    /**
     * 
     * @type {StatesEnum}
     * @memberof User
     */
    States?: StatesEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    RefreshToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    RefreshTokenExpiryTime?: string;
    /**
     * 
     * @type {Array<UserDeviceToken>}
     * @memberof User
     */
    UserDeviceTokens?: Array<UserDeviceToken> | null;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    LastTimeReadNoti?: string;
}
/**
 * 
 * @export
 * @interface UserDeviceToken
 */
export interface UserDeviceToken {
    /**
     * 
     * @type {number}
     * @memberof UserDeviceToken
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDeviceToken
     */
    UserId?: number;
    /**
     * 
     * @type {User}
     * @memberof UserDeviceToken
     */
    User?: User;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    DeviceToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    DeviceId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDeviceToken
     */
    UdId?: string | null;
}
/**
 * 
 * @export
 * @interface UserDto
 */
export interface UserDto {
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof UserDto
     */
    CompanyType?: CompanyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserDto
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    FullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    Email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    Company?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserDto
     */
    Department?: string | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof UserDto
     */
    States?: StatesEnum;
}
/**
 * 
 * @export
 * @interface UserDtoListResult
 */
export interface UserDtoListResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDtoListResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDtoListResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UserDtoListResult
     */
    Data?: Array<UserDto> | null;
}
/**
 * 
 * @export
 * @interface UserDtoPaginatedResult
 */
export interface UserDtoPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof UserDtoPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserDtoPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<UserDto>}
     * @memberof UserDtoPaginatedResult
     */
    Data?: Array<UserDto> | null;
    /**
     * 
     * @type {number}
     * @memberof UserDtoPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDtoPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDtoPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof UserDtoPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    Id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    FullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    Email?: string | null;
    /**
     * 
     * @type {LanguageEnum}
     * @memberof UserResponse
     */
    Language?: LanguageEnum;
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof UserResponse
     */
    CompanyType?: CompanyTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    DepartmentId?: number | null;
    /**
     * 
     * @type {Array<VendorModel>}
     * @memberof UserResponse
     */
    Vendors?: Array<VendorModel> | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof UserResponse
     */
    States?: StatesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    EmailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    ProfilePictureDataUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    CreatedDate?: string;
}
/**
 * 
 * @export
 * @interface UserResponseIResult
 */
export interface UserResponseIResult {
    /**
     * 
     * @type {UserResponse}
     * @memberof UserResponseIResult
     */
    Data?: UserResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserResponseIResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponseIResult
     */
    Succeeded?: boolean;
}
/**
 * 
 * @export
 * @interface UserRoleModel
 */
export interface UserRoleModel {
    /**
     * 
     * @type {string}
     * @memberof UserRoleModel
     */
    RoleName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserRoleModel
     */
    RoleDescription?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRoleModel
     */
    Selected?: boolean;
}
/**
 * 
 * @export
 * @interface UserRolesResponse
 */
export interface UserRolesResponse {
    /**
     * 
     * @type {Array<UserRoleModel>}
     * @memberof UserRolesResponse
     */
    UserRoles?: Array<UserRoleModel> | null;
}
/**
 * 
 * @export
 * @interface UserRolesResponseIResult
 */
export interface UserRolesResponseIResult {
    /**
     * 
     * @type {UserRolesResponse}
     * @memberof UserRolesResponseIResult
     */
    Data?: UserRolesResponse;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserRolesResponseIResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserRolesResponseIResult
     */
    Succeeded?: boolean;
}
/**
 * 
 * @export
 * @interface UserSallingGroup
 */
export interface UserSallingGroup {
    /**
     * 
     * @type {number}
     * @memberof UserSallingGroup
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    UserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    NormalizedUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    Email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    NormalizedEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSallingGroup
     */
    EmailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    PasswordHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    SecurityStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    ConcurrencyStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSallingGroup
     */
    PhoneNumberConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserSallingGroup
     */
    TwoFactorEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    LockoutEnd?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserSallingGroup
     */
    LockoutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserSallingGroup
     */
    AccessFailedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    FullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    ProfilePictureDataUrl?: string | null;
    /**
     * 
     * @type {LanguageEnum}
     * @memberof UserSallingGroup
     */
    Language?: LanguageEnum;
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof UserSallingGroup
     */
    CompanyType?: CompanyTypeEnum;
    /**
     * 
     * @type {StatesEnum}
     * @memberof UserSallingGroup
     */
    States?: StatesEnum;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    RefreshToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    RefreshTokenExpiryTime?: string;
    /**
     * 
     * @type {Array<UserDeviceToken>}
     * @memberof UserSallingGroup
     */
    UserDeviceTokens?: Array<UserDeviceToken> | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    LastTimeReadNoti?: string;
    /**
     * 
     * @type {number}
     * @memberof UserSallingGroup
     */
    DepartmentId?: number;
    /**
     * 
     * @type {Department}
     * @memberof UserSallingGroup
     */
    Department?: Department;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof UserSallingGroup
     */
    ManagedVendors?: Array<Vendor> | null;
    /**
     * 
     * @type {string}
     * @memberof UserSallingGroup
     */
    Modules?: string | null;
}
/**
 * 
 * @export
 * @interface UserVendor
 */
export interface UserVendor {
    /**
     * 
     * @type {number}
     * @memberof UserVendor
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    UserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    NormalizedUserName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    Email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    NormalizedEmail?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserVendor
     */
    EmailConfirmed?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    PasswordHash?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    SecurityStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    ConcurrencyStamp?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserVendor
     */
    PhoneNumberConfirmed?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserVendor
     */
    TwoFactorEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    LockoutEnd?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UserVendor
     */
    LockoutEnabled?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserVendor
     */
    AccessFailedCount?: number;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    FullName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    ProfilePictureDataUrl?: string | null;
    /**
     * 
     * @type {LanguageEnum}
     * @memberof UserVendor
     */
    Language?: LanguageEnum;
    /**
     * 
     * @type {CompanyTypeEnum}
     * @memberof UserVendor
     */
    CompanyType?: CompanyTypeEnum;
    /**
     * 
     * @type {StatesEnum}
     * @memberof UserVendor
     */
    States?: StatesEnum;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    RefreshToken?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    RefreshTokenExpiryTime?: string;
    /**
     * 
     * @type {Array<UserDeviceToken>}
     * @memberof UserVendor
     */
    UserDeviceTokens?: Array<UserDeviceToken> | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    LastTimeReadNoti?: string;
    /**
     * 
     * @type {number}
     * @memberof UserVendor
     */
    VendorId?: number;
    /**
     * 
     * @type {Vendor}
     * @memberof UserVendor
     */
    Vendor?: Vendor;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    VendorIds?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UserVendor
     */
    Modules?: string | null;
}
/**
 * 
 * @export
 * @interface UserVendorModel
 */
export interface UserVendorModel {
    /**
     * 
     * @type {number}
     * @memberof UserVendorModel
     */
    VendorId?: number;
    /**
     * 
     * @type {number}
     * @memberof UserVendorModel
     */
    UserId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof UserVendorModel
     */
    UserIds?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface Vendor
 */
export interface Vendor {
    /**
     * 
     * @type {number}
     * @memberof Vendor
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    Name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    ContactPerson?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    Email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    Address?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Vendor
     */
    PhoneNumber?: string | null;
    /**
     * 
     * @type {Array<ProductType>}
     * @memberof Vendor
     */
    ProductTypes?: Array<ProductType> | null;
    /**
     * 
     * @type {StatesEnum}
     * @memberof Vendor
     */
    States?: StatesEnum;
    /**
     * 
     * @type {Array<UserSallingGroup>}
     * @memberof Vendor
     */
    UserSallingGroups?: Array<UserSallingGroup> | null;
    /**
     * 
     * @type {Array<VendorMatrixItemModule>}
     * @memberof Vendor
     */
    VendorMatrixItemModules?: Array<VendorMatrixItemModule> | null;
    /**
     * 
     * @type {Array<ContactVendor>}
     * @memberof Vendor
     */
    ContactVendors?: Array<ContactVendor> | null;
}
/**
 * 
 * @export
 * @interface VendorMatrixItemModule
 */
export interface VendorMatrixItemModule {
    /**
     * 
     * @type {number}
     * @memberof VendorMatrixItemModule
     */
    Id?: number;
    /**
     * 
     * @type {number}
     * @memberof VendorMatrixItemModule
     */
    VendorId?: number;
    /**
     * 
     * @type {Vendor}
     * @memberof VendorMatrixItemModule
     */
    Vendor?: Vendor;
    /**
     * 
     * @type {number}
     * @memberof VendorMatrixItemModule
     */
    MatrixItemId?: number;
    /**
     * 
     * @type {number}
     * @memberof VendorMatrixItemModule
     */
    MatrixItemModuleId?: number;
}
/**
 * 
 * @export
 * @interface VendorModel
 */
export interface VendorModel {
    /**
     * 
     * @type {number}
     * @memberof VendorModel
     */
    Id?: number;
    /**
     * 
     * @type {string}
     * @memberof VendorModel
     */
    Name?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof VendorModel
     */
    InUse?: boolean;
}
/**
 * 
 * @export
 * @interface VendorPaginatedResult
 */
export interface VendorPaginatedResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof VendorPaginatedResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VendorPaginatedResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Array<Vendor>}
     * @memberof VendorPaginatedResult
     */
    Data?: Array<Vendor> | null;
    /**
     * 
     * @type {number}
     * @memberof VendorPaginatedResult
     */
    CurrentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof VendorPaginatedResult
     */
    TotalPages?: number;
    /**
     * 
     * @type {number}
     * @memberof VendorPaginatedResult
     */
    TotalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof VendorPaginatedResult
     */
    PageSize?: number;
}
/**
 * 
 * @export
 * @interface VendorResult
 */
export interface VendorResult {
    /**
     * 
     * @type {Array<string>}
     * @memberof VendorResult
     */
    Messages?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof VendorResult
     */
    Succeeded?: boolean;
    /**
     * 
     * @type {Vendor}
     * @memberof VendorResult
     */
    Data?: Vendor;
}
/**
 * 
 * @export
 * @interface VendorWithModuleChosen
 */
export interface VendorWithModuleChosen {
    /**
     * 
     * @type {number}
     * @memberof VendorWithModuleChosen
     */
    VendorId?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof VendorWithModuleChosen
     */
    ModuleChosenIds?: Array<number> | null;
}

/**
 * AccountApi - axios parameter creator
 * @export
 */
export const AccountApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Change Password
         * @param {ChangePasswordCommand} [changePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAccountChangePasswordPut: async (changePasswordCommand?: ChangePasswordCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/account/ChangePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileRequest} [updateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAccountUpdateProfilePut: async (updateProfileRequest?: UpdateProfileRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/account/UpdateProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AccountApi - functional programming interface
 * @export
 */
export const AccountApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AccountApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Change Password
         * @param {ChangePasswordCommand} [changePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAccountChangePasswordPut(changePasswordCommand?: ChangePasswordCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAccountChangePasswordPut(changePasswordCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileRequest} [updateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityAccountUpdateProfilePut(updateProfileRequest?: UpdateProfileRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityAccountUpdateProfilePut(updateProfileRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AccountApi - factory interface
 * @export
 */
export const AccountApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AccountApiFp(configuration)
    return {
        /**
         * 
         * @summary Change Password
         * @param {ChangePasswordCommand} [changePasswordCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAccountChangePasswordPut(changePasswordCommand?: ChangePasswordCommand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiIdentityAccountChangePasswordPut(changePasswordCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Profile
         * @param {UpdateProfileRequest} [updateProfileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityAccountUpdateProfilePut(updateProfileRequest?: UpdateProfileRequest, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiIdentityAccountUpdateProfilePut(updateProfileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AccountApi - object-oriented interface
 * @export
 * @class AccountApi
 * @extends {BaseAPI}
 */
export class AccountApi extends BaseAPI {
    /**
     * 
     * @summary Change Password
     * @param {ChangePasswordCommand} [changePasswordCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiIdentityAccountChangePasswordPut(changePasswordCommand?: ChangePasswordCommand, options?: any) {
        return AccountApiFp(this.configuration).apiIdentityAccountChangePasswordPut(changePasswordCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Profile
     * @param {UpdateProfileRequest} [updateProfileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AccountApi
     */
    public apiIdentityAccountUpdateProfilePut(updateProfileRequest?: UpdateProfileRequest, options?: any) {
        return AccountApiFp(this.configuration).apiIdentityAccountUpdateProfilePut(updateProfileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BrandsApi - axios parameter creator
 * @export
 */
export const BrandsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBrandsIdGet', 'id', id)
            const localVarPath = `/api/Brands/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiBrandsIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Brands/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedBrandsQuery} [getPagedBrandsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsPagedPost: async (getPagedBrandsQuery?: GetPagedBrandsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Brands/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedBrandsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditBrandCommand} [addEditBrandCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsPost: async (addEditBrandCommand?: AddEditBrandCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditBrandCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BrandsApi - functional programming interface
 * @export
 */
export const BrandsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BrandsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBrandsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBrandsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBrandsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBrandsIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedBrandsQuery} [getPagedBrandsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBrandsPagedPost(getPagedBrandsQuery?: GetPagedBrandsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrandPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBrandsPagedPost(getPagedBrandsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditBrandCommand} [addEditBrandCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiBrandsPost(addEditBrandCommand?: AddEditBrandCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiBrandsPost(addEditBrandCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BrandsApi - factory interface
 * @export
 */
export const BrandsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BrandsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsIdGet(id: number, options?: any): AxiosPromise<BrandResult> {
            return localVarFp.apiBrandsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiBrandsIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedBrandsQuery} [getPagedBrandsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsPagedPost(getPagedBrandsQuery?: GetPagedBrandsQuery, options?: any): AxiosPromise<BrandPaginatedResult> {
            return localVarFp.apiBrandsPagedPost(getPagedBrandsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditBrandCommand} [addEditBrandCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiBrandsPost(addEditBrandCommand?: AddEditBrandCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiBrandsPost(addEditBrandCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BrandsApi - object-oriented interface
 * @export
 * @class BrandsApi
 * @extends {BaseAPI}
 */
export class BrandsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public apiBrandsIdGet(id: number, options?: any) {
        return BrandsApiFp(this.configuration).apiBrandsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public apiBrandsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return BrandsApiFp(this.configuration).apiBrandsIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedBrandsQuery} [getPagedBrandsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public apiBrandsPagedPost(getPagedBrandsQuery?: GetPagedBrandsQuery, options?: any) {
        return BrandsApiFp(this.configuration).apiBrandsPagedPost(getPagedBrandsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditBrandCommand} [addEditBrandCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BrandsApi
     */
    public apiBrandsPost(addEditBrandCommand?: AddEditBrandCommand, options?: any) {
        return BrandsApiFp(this.configuration).apiBrandsPost(addEditBrandCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CategoriesApi - axios parameter creator
 * @export
 */
export const CategoriesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCategoriesIdGet', 'id', id)
            const localVarPath = `/api/Categories/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiCategoriesIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Categories/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedCategorysQuery} [getPagedCategorysQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesPagedPost: async (getPagedCategorysQuery?: GetPagedCategorysQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Categories/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedCategorysQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditCategoryCommand} [addEditCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesPost: async (addEditCategoryCommand?: AddEditCategoryCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditCategoryCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CategoriesApi - functional programming interface
 * @export
 */
export const CategoriesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CategoriesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedCategorysQuery} [getPagedCategorysQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesPagedPost(getPagedCategorysQuery?: GetPagedCategorysQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CategoryPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesPagedPost(getPagedCategorysQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditCategoryCommand} [addEditCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCategoriesPost(addEditCategoryCommand?: AddEditCategoryCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiCategoriesPost(addEditCategoryCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CategoriesApi - factory interface
 * @export
 */
export const CategoriesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CategoriesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdGet(id: number, options?: any): AxiosPromise<CategoryResult> {
            return localVarFp.apiCategoriesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiCategoriesIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedCategorysQuery} [getPagedCategorysQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesPagedPost(getPagedCategorysQuery?: GetPagedCategorysQuery, options?: any): AxiosPromise<CategoryPaginatedResult> {
            return localVarFp.apiCategoriesPagedPost(getPagedCategorysQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditCategoryCommand} [addEditCategoryCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCategoriesPost(addEditCategoryCommand?: AddEditCategoryCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiCategoriesPost(addEditCategoryCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CategoriesApi - object-oriented interface
 * @export
 * @class CategoriesApi
 * @extends {BaseAPI}
 */
export class CategoriesApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public apiCategoriesIdGet(id: number, options?: any) {
        return CategoriesApiFp(this.configuration).apiCategoriesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public apiCategoriesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return CategoriesApiFp(this.configuration).apiCategoriesIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedCategorysQuery} [getPagedCategorysQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public apiCategoriesPagedPost(getPagedCategorysQuery?: GetPagedCategorysQuery, options?: any) {
        return CategoriesApiFp(this.configuration).apiCategoriesPagedPost(getPagedCategorysQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditCategoryCommand} [addEditCategoryCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CategoriesApi
     */
    public apiCategoriesPost(addEditCategoryCommand?: AddEditCategoryCommand, options?: any) {
        return CategoriesApiFp(this.configuration).apiCategoriesPost(addEditCategoryCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ComponentsApi - axios parameter creator
 * @export
 */
export const ComponentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiComponentsIdGet', 'id', id)
            const localVarPath = `/api/Components/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiComponentsIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Components/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedComponentsQuery} [getPagedComponentsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsPagedPost: async (getPagedComponentsQuery?: GetPagedComponentsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Components/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedComponentsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditComponentCommand} [addEditComponentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsPost: async (addEditComponentCommand?: AddEditComponentCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Components`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditComponentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCBrandById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCBrandById', 'id', id)
            const localVarPath = `/api/Components/Brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CBrandPagingRequestModel} [cBrandPagingRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCBrands: async (cBrandPagingRequestModel?: CBrandPagingRequestModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Components/Brands`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cBrandPagingRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCModelById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCModelById', 'id', id)
            const localVarPath = `/api/Components/Model/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CModelPagingRequestModel} [cModelPagingRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCModels: async (cModelPagingRequestModel?: CModelPagingRequestModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Components/Models`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cModelPagingRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCBrand: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCBrand', 'id', id)
            const localVarPath = `/api/Components/Brand/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCModel: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeCModel', 'id', id)
            const localVarPath = `/api/Components/Model/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CBrandModel} [cBrandModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCBrand: async (cBrandModel?: CBrandModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Components/Brand`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cBrandModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CModelModel} [cModelModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCModel: async (cModelModel?: CModelModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Components/Model`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(cModelModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ComponentsApi - functional programming interface
 * @export
 */
export const ComponentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ComponentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComponentsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComponentsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComponentsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComponentsIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedComponentsQuery} [getPagedComponentsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComponentsPagedPost(getPagedComponentsQuery?: GetPagedComponentsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ComponentPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComponentsPagedPost(getPagedComponentsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditComponentCommand} [addEditComponentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiComponentsPost(addEditComponentCommand?: AddEditComponentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiComponentsPost(addEditComponentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCBrandById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CBrandModelApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCBrandById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CBrandPagingRequestModel} [cBrandPagingRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCBrands(cBrandPagingRequestModel?: CBrandPagingRequestModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CBrandModelIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCBrands(cBrandPagingRequestModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCModelById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CModelModelApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCModelById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CModelPagingRequestModel} [cModelPagingRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCModels(cModelPagingRequestModel?: CModelPagingRequestModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CModelModelIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCModels(cModelPagingRequestModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCBrand(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCBrand(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeCModel(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeCModel(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CBrandModel} [cBrandModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCBrand(cBrandModel?: CBrandModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCBrand(cBrandModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CModelModel} [cModelModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCModel(cModelModel?: CModelModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCModel(cModelModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ComponentsApi - factory interface
 * @export
 */
export const ComponentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ComponentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsIdGet(id: number, options?: any): AxiosPromise<ComponentResult> {
            return localVarFp.apiComponentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiComponentsIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedComponentsQuery} [getPagedComponentsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsPagedPost(getPagedComponentsQuery?: GetPagedComponentsQuery, options?: any): AxiosPromise<ComponentPaginatedResult> {
            return localVarFp.apiComponentsPagedPost(getPagedComponentsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditComponentCommand} [addEditComponentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiComponentsPost(addEditComponentCommand?: AddEditComponentCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiComponentsPost(addEditComponentCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCBrandById(id: number, options?: any): AxiosPromise<CBrandModelApiResponse> {
            return localVarFp.getCBrandById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CBrandPagingRequestModel} [cBrandPagingRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCBrands(cBrandPagingRequestModel?: CBrandPagingRequestModel, options?: any): AxiosPromise<CBrandModelIEnumerableApiResponse> {
            return localVarFp.getCBrands(cBrandPagingRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCModelById(id: number, options?: any): AxiosPromise<CModelModelApiResponse> {
            return localVarFp.getCModelById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CModelPagingRequestModel} [cModelPagingRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCModels(cModelPagingRequestModel?: CModelPagingRequestModel, options?: any): AxiosPromise<CModelModelIEnumerableApiResponse> {
            return localVarFp.getCModels(cModelPagingRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCBrand(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeCBrand(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCModel(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.removeCModel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CBrandModel} [cBrandModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCBrand(cBrandModel?: CBrandModel, options?: any): AxiosPromise<BooleanApiResponse> {
            return localVarFp.updateCBrand(cBrandModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CModelModel} [cModelModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCModel(cModelModel?: CModelModel, options?: any): AxiosPromise<BooleanApiResponse> {
            return localVarFp.updateCModel(cModelModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ComponentsApi - object-oriented interface
 * @export
 * @class ComponentsApi
 * @extends {BaseAPI}
 */
export class ComponentsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public apiComponentsIdGet(id: number, options?: any) {
        return ComponentsApiFp(this.configuration).apiComponentsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public apiComponentsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return ComponentsApiFp(this.configuration).apiComponentsIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedComponentsQuery} [getPagedComponentsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public apiComponentsPagedPost(getPagedComponentsQuery?: GetPagedComponentsQuery, options?: any) {
        return ComponentsApiFp(this.configuration).apiComponentsPagedPost(getPagedComponentsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditComponentCommand} [addEditComponentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public apiComponentsPost(addEditComponentCommand?: AddEditComponentCommand, options?: any) {
        return ComponentsApiFp(this.configuration).apiComponentsPost(addEditComponentCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public getCBrandById(id: number, options?: any) {
        return ComponentsApiFp(this.configuration).getCBrandById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CBrandPagingRequestModel} [cBrandPagingRequestModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public getCBrands(cBrandPagingRequestModel?: CBrandPagingRequestModel, options?: any) {
        return ComponentsApiFp(this.configuration).getCBrands(cBrandPagingRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public getCModelById(id: number, options?: any) {
        return ComponentsApiFp(this.configuration).getCModelById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CModelPagingRequestModel} [cModelPagingRequestModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public getCModels(cModelPagingRequestModel?: CModelPagingRequestModel, options?: any) {
        return ComponentsApiFp(this.configuration).getCModels(cModelPagingRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public removeCBrand(id: number, options?: any) {
        return ComponentsApiFp(this.configuration).removeCBrand(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public removeCModel(id: number, options?: any) {
        return ComponentsApiFp(this.configuration).removeCModel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CBrandModel} [cBrandModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public updateCBrand(cBrandModel?: CBrandModel, options?: any) {
        return ComponentsApiFp(this.configuration).updateCBrand(cBrandModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CModelModel} [cModelModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ComponentsApi
     */
    public updateCModel(cModelModel?: CModelModel, options?: any) {
        return ComponentsApiFp(this.configuration).updateCModel(cModelModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DeadlineApi - axios parameter creator
 * @export
 */
export const DeadlineApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeadlineDeadLinePushNotiGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Deadline/DeadLinePushNoti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [warningOverdueDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeadlineGetModuleBeforeExpireDateGet: async (warningOverdueDays?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Deadline/GetModuleBeforeExpireDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (warningOverdueDays !== undefined) {
                localVarQueryParameter['warningOverdueDays'] = warningOverdueDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeadlineGetModuleExpireDateGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Deadline/GetModuleExpireDate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DeadlineApi - functional programming interface
 * @export
 */
export const DeadlineApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DeadlineApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeadlineDeadLinePushNotiGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MatrixItemModule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeadlineDeadLinePushNotiGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [warningOverdueDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeadlineGetModuleBeforeExpireDateGet(warningOverdueDays?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MatrixItemModule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeadlineGetModuleBeforeExpireDateGet(warningOverdueDays, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDeadlineGetModuleExpireDateGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MatrixItemModule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDeadlineGetModuleExpireDateGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DeadlineApi - factory interface
 * @export
 */
export const DeadlineApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DeadlineApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeadlineDeadLinePushNotiGet(options?: any): AxiosPromise<Array<MatrixItemModule>> {
            return localVarFp.apiDeadlineDeadLinePushNotiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [warningOverdueDays] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeadlineGetModuleBeforeExpireDateGet(warningOverdueDays?: number, options?: any): AxiosPromise<Array<MatrixItemModule>> {
            return localVarFp.apiDeadlineGetModuleBeforeExpireDateGet(warningOverdueDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDeadlineGetModuleExpireDateGet(options?: any): AxiosPromise<Array<MatrixItemModule>> {
            return localVarFp.apiDeadlineGetModuleExpireDateGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DeadlineApi - object-oriented interface
 * @export
 * @class DeadlineApi
 * @extends {BaseAPI}
 */
export class DeadlineApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeadlineApi
     */
    public apiDeadlineDeadLinePushNotiGet(options?: any) {
        return DeadlineApiFp(this.configuration).apiDeadlineDeadLinePushNotiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [warningOverdueDays] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeadlineApi
     */
    public apiDeadlineGetModuleBeforeExpireDateGet(warningOverdueDays?: number, options?: any) {
        return DeadlineApiFp(this.configuration).apiDeadlineGetModuleBeforeExpireDateGet(warningOverdueDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DeadlineApi
     */
    public apiDeadlineGetModuleExpireDateGet(options?: any) {
        return DeadlineApiFp(this.configuration).apiDeadlineGetModuleExpireDateGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DepartmentsApi - axios parameter creator
 * @export
 */
export const DepartmentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All Departments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Department By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDepartmentsIdGet', 'id', id)
            const localVarPath = `/api/Departments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDepartmentsIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Departments/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedDepartmentsQuery} [getPagedDepartmentsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsPagedPost: async (getPagedDepartmentsQuery?: GetPagedDepartmentsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Departments/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedDepartmentsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create/Update a Department
         * @param {AddEditDepartmentCommand} [addEditDepartmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsPost: async (addEditDepartmentCommand?: AddEditDepartmentCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Departments`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditDepartmentCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DepartmentsApi - functional programming interface
 * @export
 */
export const DepartmentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DepartmentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All Departments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDepartmentsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentWithCountUserListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDepartmentsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Department By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDepartmentsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDepartmentsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDepartmentsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDepartmentsIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedDepartmentsQuery} [getPagedDepartmentsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDepartmentsPagedPost(getPagedDepartmentsQuery?: GetPagedDepartmentsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DepartmentPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDepartmentsPagedPost(getPagedDepartmentsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create/Update a Department
         * @param {AddEditDepartmentCommand} [addEditDepartmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDepartmentsPost(addEditDepartmentCommand?: AddEditDepartmentCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDepartmentsPost(addEditDepartmentCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DepartmentsApi - factory interface
 * @export
 */
export const DepartmentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DepartmentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All Departments
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsGet(options?: any): AxiosPromise<DepartmentWithCountUserListResult> {
            return localVarFp.apiDepartmentsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Department By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsIdGet(id: number, options?: any): AxiosPromise<DepartmentResult> {
            return localVarFp.apiDepartmentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiDepartmentsIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedDepartmentsQuery} [getPagedDepartmentsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsPagedPost(getPagedDepartmentsQuery?: GetPagedDepartmentsQuery, options?: any): AxiosPromise<DepartmentPaginatedResult> {
            return localVarFp.apiDepartmentsPagedPost(getPagedDepartmentsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create/Update a Department
         * @param {AddEditDepartmentCommand} [addEditDepartmentCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDepartmentsPost(addEditDepartmentCommand?: AddEditDepartmentCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiDepartmentsPost(addEditDepartmentCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DepartmentsApi - object-oriented interface
 * @export
 * @class DepartmentsApi
 * @extends {BaseAPI}
 */
export class DepartmentsApi extends BaseAPI {
    /**
     * 
     * @summary Get All Departments
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiDepartmentsGet(options?: any) {
        return DepartmentsApiFp(this.configuration).apiDepartmentsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Department By Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiDepartmentsIdGet(id: number, options?: any) {
        return DepartmentsApiFp(this.configuration).apiDepartmentsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiDepartmentsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return DepartmentsApiFp(this.configuration).apiDepartmentsIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedDepartmentsQuery} [getPagedDepartmentsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiDepartmentsPagedPost(getPagedDepartmentsQuery?: GetPagedDepartmentsQuery, options?: any) {
        return DepartmentsApiFp(this.configuration).apiDepartmentsPagedPost(getPagedDepartmentsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create/Update a Department
     * @param {AddEditDepartmentCommand} [addEditDepartmentCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepartmentsApi
     */
    public apiDepartmentsPost(addEditDepartmentCommand?: AddEditDepartmentCommand, options?: any) {
        return DepartmentsApiFp(this.configuration).apiDepartmentsPost(addEditDepartmentCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DocumentsApi - axios parameter creator
 * @export
 */
export const DocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Dowload or view document content by id
         * @param {number} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdFileNameGet: async (id: number, fileName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdFileNameGet', 'id', id)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiDocumentsIdFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/Documents/{id}/{fileName}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dowload or view document content by id (With Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdGet', 'id', id)
            const localVarPath = `/api/Documents/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dowload or view document content by id
         * @param {number} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdThumbFileNameGet: async (id: number, fileName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdThumbFileNameGet', 'id', id)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiDocumentsIdThumbFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/Documents/{id}/Thumb/{fileName}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Dowload or view document content by id (With Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdThumbGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiDocumentsIdThumbGet', 'id', id)
            const localVarPath = `/api/Documents/{id}/Thumb`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentsApi - functional programming interface
 * @export
 */
export const DocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Dowload or view document content by id
         * @param {number} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdFileNameGet(id: number, fileName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdFileNameGet(id, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Dowload or view document content by id (With Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Dowload or view document content by id
         * @param {number} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdThumbFileNameGet(id: number, fileName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdThumbFileNameGet(id, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Dowload or view document content by id (With Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiDocumentsIdThumbGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiDocumentsIdThumbGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DocumentsApi - factory interface
 * @export
 */
export const DocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Dowload or view document content by id
         * @param {number} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdFileNameGet(id: number, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentsIdFileNameGet(id, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dowload or view document content by id (With Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdGet(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dowload or view document content by id
         * @param {number} id 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdThumbFileNameGet(id: number, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentsIdThumbFileNameGet(id, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Dowload or view document content by id (With Auth)
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiDocumentsIdThumbGet(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiDocumentsIdThumbGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
export class DocumentsApi extends BaseAPI {
    /**
     * 
     * @summary Dowload or view document content by id
     * @param {number} id 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiDocumentsIdFileNameGet(id: number, fileName: string, options?: any) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdFileNameGet(id, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dowload or view document content by id (With Auth)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiDocumentsIdGet(id: number, options?: any) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dowload or view document content by id
     * @param {number} id 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiDocumentsIdThumbFileNameGet(id: number, fileName: string, options?: any) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdThumbFileNameGet(id, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Dowload or view document content by id (With Auth)
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    public apiDocumentsIdThumbGet(id: number, options?: any) {
        return DocumentsApiFp(this.configuration).apiDocumentsIdThumbGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MatrixDocumentsApi - axios parameter creator
 * @export
 */
export const MatrixDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdDelete: async (matrixModuleId: number, documentIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdDelete', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixDocuments/{matrixModuleId}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentIds) {
                localVarQueryParameter['documentIds'] = documentIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdGet: async (matrixModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdGet', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixDocuments/{matrixModuleId}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get matrixItemModule document by documentId and name
         * @param {number} matrixModuleId 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet: async (matrixModuleId: number, idDocument: number, fileName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet', 'idDocument', idDocument)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/MatrixDocuments/{matrixModuleId}/{idDocument}/{fileName}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get matrixItemModule document by documentId
         * @param {number} matrixModuleId 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdIdDocumentGet: async (matrixModuleId: number, idDocument: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdIdDocumentGet', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdIdDocumentGet', 'idDocument', idDocument)
            const localVarPath = `/api/MatrixDocuments/{matrixModuleId}/{idDocument}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdPost: async (matrixModuleId: number, documents: Array<any>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdPost', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'documents' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdPost', 'documents', documents)
            const localVarPath = `/api/MatrixDocuments/{matrixModuleId}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zip matrixItemModule document and download
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdZipGet: async (matrixModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixDocumentsMatrixModuleIdZipGet', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixDocuments/{matrixModuleId}/Zip`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatrixDocumentsApi - functional programming interface
 * @export
 */
export const MatrixDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatrixDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixDocumentsMatrixModuleIdDelete(matrixModuleId: number, documentIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixDocumentsMatrixModuleIdDelete(matrixModuleId, documentIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixDocumentsMatrixModuleIdGet(matrixModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixDocumentsMatrixModuleIdGet(matrixModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get matrixItemModule document by documentId and name
         * @param {number} matrixModuleId 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet(matrixModuleId: number, idDocument: number, fileName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet(matrixModuleId, idDocument, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get matrixItemModule document by documentId
         * @param {number} matrixModuleId 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixDocumentsMatrixModuleIdIdDocumentGet(matrixModuleId: number, idDocument: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixDocumentsMatrixModuleIdIdDocumentGet(matrixModuleId, idDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixDocumentsMatrixModuleIdPost(matrixModuleId: number, documents: Array<any>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixDocumentsMatrixModuleIdPost(matrixModuleId, documents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zip matrixItemModule document and download
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixDocumentsMatrixModuleIdZipGet(matrixModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixDocumentsMatrixModuleIdZipGet(matrixModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatrixDocumentsApi - factory interface
 * @export
 */
export const MatrixDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatrixDocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdDelete(matrixModuleId: number, documentIds?: Array<number>, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiMatrixDocumentsMatrixModuleIdDelete(matrixModuleId, documentIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdGet(matrixModuleId: number, options?: any): AxiosPromise<DocumentDtoListResult> {
            return localVarFp.apiMatrixDocumentsMatrixModuleIdGet(matrixModuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get matrixItemModule document by documentId and name
         * @param {number} matrixModuleId 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet(matrixModuleId: number, idDocument: number, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet(matrixModuleId, idDocument, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get matrixItemModule document by documentId
         * @param {number} matrixModuleId 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdIdDocumentGet(matrixModuleId: number, idDocument: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMatrixDocumentsMatrixModuleIdIdDocumentGet(matrixModuleId, idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdPost(matrixModuleId: number, documents: Array<any>, options?: any): AxiosPromise<DocumentListResult> {
            return localVarFp.apiMatrixDocumentsMatrixModuleIdPost(matrixModuleId, documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zip matrixItemModule document and download
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixDocumentsMatrixModuleIdZipGet(matrixModuleId: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMatrixDocumentsMatrixModuleIdZipGet(matrixModuleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatrixDocumentsApi - object-oriented interface
 * @export
 * @class MatrixDocumentsApi
 * @extends {BaseAPI}
 */
export class MatrixDocumentsApi extends BaseAPI {
    /**
     * 
     * @param {number} matrixModuleId 
     * @param {Array<number>} [documentIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixDocumentsApi
     */
    public apiMatrixDocumentsMatrixModuleIdDelete(matrixModuleId: number, documentIds?: Array<number>, options?: any) {
        return MatrixDocumentsApiFp(this.configuration).apiMatrixDocumentsMatrixModuleIdDelete(matrixModuleId, documentIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixDocumentsApi
     */
    public apiMatrixDocumentsMatrixModuleIdGet(matrixModuleId: number, options?: any) {
        return MatrixDocumentsApiFp(this.configuration).apiMatrixDocumentsMatrixModuleIdGet(matrixModuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get matrixItemModule document by documentId and name
     * @param {number} matrixModuleId 
     * @param {number} idDocument 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixDocumentsApi
     */
    public apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet(matrixModuleId: number, idDocument: number, fileName: string, options?: any) {
        return MatrixDocumentsApiFp(this.configuration).apiMatrixDocumentsMatrixModuleIdIdDocumentFileNameGet(matrixModuleId, idDocument, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get matrixItemModule document by documentId
     * @param {number} matrixModuleId 
     * @param {number} idDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixDocumentsApi
     */
    public apiMatrixDocumentsMatrixModuleIdIdDocumentGet(matrixModuleId: number, idDocument: number, options?: any) {
        return MatrixDocumentsApiFp(this.configuration).apiMatrixDocumentsMatrixModuleIdIdDocumentGet(matrixModuleId, idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {Array<any>} documents 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixDocumentsApi
     */
    public apiMatrixDocumentsMatrixModuleIdPost(matrixModuleId: number, documents: Array<any>, options?: any) {
        return MatrixDocumentsApiFp(this.configuration).apiMatrixDocumentsMatrixModuleIdPost(matrixModuleId, documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zip matrixItemModule document and download
     * @param {number} matrixModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixDocumentsApi
     */
    public apiMatrixDocumentsMatrixModuleIdZipGet(matrixModuleId: number, options?: any) {
        return MatrixDocumentsApiFp(this.configuration).apiMatrixDocumentsMatrixModuleIdZipGet(matrixModuleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MatrixItemsApi - axios parameter creator
 * @export
 */
export const MatrixItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Matrix Item=> Setting =>Add/Remove Modules
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet: async (matrixItemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/AllModuleAndAddedModuleByMatrixItem/{matrixItemId}`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {AddRemoveModuleMatrixItemCommand} [addRemoveModuleMatrixItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdAddRemoveModulePatch: async (matrixItemId: number, addRemoveModuleMatrixItemCommand?: AddRemoveModuleMatrixItemCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdAddRemoveModulePatch', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/AddRemoveModule`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRemoveModuleMatrixItemCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get 2/ Màn hình add/remove vendors
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdAddRemoveVendorGet: async (matrixItemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdAddRemoveVendorGet', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/AddRemoveVendor`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save Màn hình add/remove vendors
         * @param {number} matrixItemId 
         * @param {AddRemoveMatrixModuleVendorCommmand} [addRemoveMatrixModuleVendorCommmand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdAddRemoveVendorPatch: async (matrixItemId: number, addRemoveMatrixModuleVendorCommmand?: AddRemoveMatrixModuleVendorCommmand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdAddRemoveVendorPatch', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/AddRemoveVendor`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addRemoveMatrixModuleVendorCommmand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {Array<ModuleUserReponsive>} [moduleUserReponsive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut: async (matrixItemId: number, moduleUserReponsive?: Array<ModuleUserReponsive>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/EditMatrixItemModuleResponsive`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moduleUserReponsive, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tab General
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdGeneralGet: async (matrixItemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdGeneralGet', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/General`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet: async (matrixItemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/GetMatrixItemModuleResponsive`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet: async (matrixItemId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet', 'matrixItemId', matrixItemId)
            const localVarPath = `/api/MatrixItems/{matrixItemId}/GetMatrixItemModuleResponsiveUsers`
                .replace(`{${"matrixItemId"}}`, encodeURIComponent(String(matrixItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add one Test to Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut: async (matrixItemModuleId: number, testId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut', 'matrixItemModuleId', matrixItemModuleId)
            // verify required parameter 'testId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut', 'testId', testId)
            const localVarPath = `/api/MatrixItems/{matrixItemModuleId}/AddTestToModule/{testId}`
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)))
                .replace(`{${"testId"}}`, encodeURIComponent(String(testId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixItemModuleId 
         * @param {EditMatrixItemModuleCommand} [editMatrixItemModuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdEditPatch: async (matrixItemModuleId: number, editMatrixItemModuleCommand?: EditMatrixItemModuleCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdEditPatch', 'matrixItemModuleId', matrixItemModuleId)
            const localVarPath = `/api/MatrixItems/{matrixItemModuleId}/Edit`
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editMatrixItemModuleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get tab Module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdGet: async (matrixItemModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdGet', 'matrixItemModuleId', matrixItemModuleId)
            const localVarPath = `/api/MatrixItems/{matrixItemModuleId}`
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove Test from Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete: async (matrixItemModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete', 'matrixItemModuleId', matrixItemModuleId)
            const localVarPath = `/api/MatrixItems/{matrixItemModuleId}/RemoveTestFromModule`
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Approve Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {boolean} [isApproved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdSetApprovedPatch: async (matrixItemModuleId: number, isApproved?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdSetApprovedPatch', 'matrixItemModuleId', matrixItemModuleId)
            const localVarPath = `/api/MatrixItems/{matrixItemModuleId}/SetApproved`
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (isApproved !== undefined) {
                localVarQueryParameter['isApproved'] = isApproved;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get List Tests can be add to Matrix item module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet: async (matrixItemModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet', 'matrixItemModuleId', matrixItemModuleId)
            const localVarPath = `/api/MatrixItems/{matrixItemModuleId}/TestsCanBeAddPaged`
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatrixItemsApi - functional programming interface
 * @export
 */
export const MatrixItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatrixItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Matrix Item=> Setting =>Add/Remove Modules
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(matrixItemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemModuleCanBeAddListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(matrixItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {AddRemoveModuleMatrixItemCommand} [addRemoveModuleMatrixItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdAddRemoveModulePatch(matrixItemId: number, addRemoveModuleMatrixItemCommand?: AddRemoveModuleMatrixItemCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdAddRemoveModulePatch(matrixItemId, addRemoveModuleMatrixItemCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get 2/ Màn hình add/remove vendors
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdAddRemoveVendorGet(matrixItemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AddRemoveMatrixModuleVendorResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdAddRemoveVendorGet(matrixItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save Màn hình add/remove vendors
         * @param {number} matrixItemId 
         * @param {AddRemoveMatrixModuleVendorCommmand} [addRemoveMatrixModuleVendorCommmand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(matrixItemId: number, addRemoveMatrixModuleVendorCommmand?: AddRemoveMatrixModuleVendorCommmand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(matrixItemId, addRemoveMatrixModuleVendorCommmand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {Array<ModuleUserReponsive>} [moduleUserReponsive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(matrixItemId: number, moduleUserReponsive?: Array<ModuleUserReponsive>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(matrixItemId, moduleUserReponsive, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get tab General
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdGeneralGet(matrixItemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemGeneralResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdGeneralGet(matrixItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(matrixItemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemModuleResponsiveResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(matrixItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(matrixItemId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(matrixItemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add one Test to Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut(matrixItemModuleId: number, testId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut(matrixItemModuleId, testId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixItemModuleId 
         * @param {EditMatrixItemModuleCommand} [editMatrixItemModuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemModuleIdEditPatch(matrixItemModuleId: number, editMatrixItemModuleCommand?: EditMatrixItemModuleCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemModuleIdEditPatch(matrixItemModuleId, editMatrixItemModuleCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get tab Module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemModuleIdGet(matrixItemModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemModuleDtoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemModuleIdGet(matrixItemModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove Test from Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete(matrixItemModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete(matrixItemModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Approve Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {boolean} [isApproved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(matrixItemModuleId: number, isApproved?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(matrixItemModuleId, isApproved, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get List Tests can be add to Matrix item module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet(matrixItemModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet(matrixItemModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatrixItemsApi - factory interface
 * @export
 */
export const MatrixItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatrixItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary Matrix Item=> Setting =>Add/Remove Modules
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(matrixItemId: number, options?: any): AxiosPromise<MatrixItemModuleCanBeAddListResult> {
            return localVarFp.apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(matrixItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {AddRemoveModuleMatrixItemCommand} [addRemoveModuleMatrixItemCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdAddRemoveModulePatch(matrixItemId: number, addRemoveModuleMatrixItemCommand?: AddRemoveModuleMatrixItemCommand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdAddRemoveModulePatch(matrixItemId, addRemoveModuleMatrixItemCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get 2/ Màn hình add/remove vendors
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdAddRemoveVendorGet(matrixItemId: number, options?: any): AxiosPromise<AddRemoveMatrixModuleVendorResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdAddRemoveVendorGet(matrixItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save Màn hình add/remove vendors
         * @param {number} matrixItemId 
         * @param {AddRemoveMatrixModuleVendorCommmand} [addRemoveMatrixModuleVendorCommmand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(matrixItemId: number, addRemoveMatrixModuleVendorCommmand?: AddRemoveMatrixModuleVendorCommmand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(matrixItemId, addRemoveMatrixModuleVendorCommmand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {Array<ModuleUserReponsive>} [moduleUserReponsive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(matrixItemId: number, moduleUserReponsive?: Array<ModuleUserReponsive>, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(matrixItemId, moduleUserReponsive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tab General
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdGeneralGet(matrixItemId: number, options?: any): AxiosPromise<MatrixItemGeneralResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdGeneralGet(matrixItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(matrixItemId: number, options?: any): AxiosPromise<MatrixItemModuleResponsiveResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(matrixItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(matrixItemId: number, options?: any): AxiosPromise<UserDtoListResult> {
            return localVarFp.apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(matrixItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add one Test to Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {number} testId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut(matrixItemModuleId: number, testId: number, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut(matrixItemModuleId, testId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixItemModuleId 
         * @param {EditMatrixItemModuleCommand} [editMatrixItemModuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdEditPatch(matrixItemModuleId: number, editMatrixItemModuleCommand?: EditMatrixItemModuleCommand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemModuleIdEditPatch(matrixItemModuleId, editMatrixItemModuleCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get tab Module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdGet(matrixItemModuleId: number, options?: any): AxiosPromise<MatrixItemModuleDtoResult> {
            return localVarFp.apiMatrixItemsMatrixItemModuleIdGet(matrixItemModuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove Test from Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete(matrixItemModuleId: number, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete(matrixItemModuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Approve Matrix item Module
         * @param {number} matrixItemModuleId 
         * @param {boolean} [isApproved] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(matrixItemModuleId: number, isApproved?: boolean, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(matrixItemModuleId, isApproved, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get List Tests can be add to Matrix item module
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet(matrixItemModuleId: number, options?: any): AxiosPromise<TestPaginatedResult> {
            return localVarFp.apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet(matrixItemModuleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatrixItemsApi - object-oriented interface
 * @export
 * @class MatrixItemsApi
 * @extends {BaseAPI}
 */
export class MatrixItemsApi extends BaseAPI {
    /**
     * 
     * @summary Matrix Item=> Setting =>Add/Remove Modules
     * @param {number} matrixItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(matrixItemId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsAllModuleAndAddedModuleByMatrixItemMatrixItemIdGet(matrixItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixItemId 
     * @param {AddRemoveModuleMatrixItemCommand} [addRemoveModuleMatrixItemCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdAddRemoveModulePatch(matrixItemId: number, addRemoveModuleMatrixItemCommand?: AddRemoveModuleMatrixItemCommand, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdAddRemoveModulePatch(matrixItemId, addRemoveModuleMatrixItemCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get 2/ Màn hình add/remove vendors
     * @param {number} matrixItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdAddRemoveVendorGet(matrixItemId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdAddRemoveVendorGet(matrixItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save Màn hình add/remove vendors
     * @param {number} matrixItemId 
     * @param {AddRemoveMatrixModuleVendorCommmand} [addRemoveMatrixModuleVendorCommmand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(matrixItemId: number, addRemoveMatrixModuleVendorCommmand?: AddRemoveMatrixModuleVendorCommmand, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdAddRemoveVendorPatch(matrixItemId, addRemoveMatrixModuleVendorCommmand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixItemId 
     * @param {Array<ModuleUserReponsive>} [moduleUserReponsive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(matrixItemId: number, moduleUserReponsive?: Array<ModuleUserReponsive>, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdEditMatrixItemModuleResponsivePut(matrixItemId, moduleUserReponsive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tab General
     * @param {number} matrixItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdGeneralGet(matrixItemId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdGeneralGet(matrixItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(matrixItemId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveGet(matrixItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(matrixItemId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemIdGetMatrixItemModuleResponsiveUsersGet(matrixItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add one Test to Matrix item Module
     * @param {number} matrixItemModuleId 
     * @param {number} testId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut(matrixItemModuleId: number, testId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemModuleIdAddTestToModuleTestIdPut(matrixItemModuleId, testId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixItemModuleId 
     * @param {EditMatrixItemModuleCommand} [editMatrixItemModuleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemModuleIdEditPatch(matrixItemModuleId: number, editMatrixItemModuleCommand?: EditMatrixItemModuleCommand, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemModuleIdEditPatch(matrixItemModuleId, editMatrixItemModuleCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get tab Module
     * @param {number} matrixItemModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemModuleIdGet(matrixItemModuleId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemModuleIdGet(matrixItemModuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove Test from Matrix item Module
     * @param {number} matrixItemModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete(matrixItemModuleId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemModuleIdRemoveTestFromModuleDelete(matrixItemModuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Approve Matrix item Module
     * @param {number} matrixItemModuleId 
     * @param {boolean} [isApproved] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(matrixItemModuleId: number, isApproved?: boolean, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemModuleIdSetApprovedPatch(matrixItemModuleId, isApproved, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get List Tests can be add to Matrix item module
     * @param {number} matrixItemModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixItemsApi
     */
    public apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet(matrixItemModuleId: number, options?: any) {
        return MatrixItemsApiFp(this.configuration).apiMatrixItemsMatrixItemModuleIdTestsCanBeAddPagedGet(matrixItemModuleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MatrixMessagesApi - axios parameter creator
 * @export
 */
export const MatrixMessagesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} [messageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdDelete: async (matrixModuleId: number, messageId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdDelete', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (messageId !== undefined) {
                localVarQueryParameter['messageId'] = messageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdGet: async (matrixModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdGet', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete: async (matrixModuleId: number, messageId: number, documentIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete', 'messageId', messageId)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}/{messageId}/Documents`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentIds) {
                localVarQueryParameter['documentIds'] = documentIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet: async (matrixModuleId: number, messageId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet', 'messageId', messageId)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}/{messageId}/Documents`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet: async (matrixModuleId: number, messageId: number, idDocument: number, fileName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet', 'messageId', messageId)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet', 'idDocument', idDocument)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}/{messageId}/Documents/{idDocument}/{fileName}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)))
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet: async (matrixModuleId: number, messageId: number, idDocument: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet', 'messageId', messageId)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet', 'idDocument', idDocument)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}/{messageId}/Documents/{idDocument}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)))
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost: async (matrixModuleId: number, messageId: number, documents: Array<any>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost', 'matrixModuleId', matrixModuleId)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost', 'messageId', messageId)
            // verify required parameter 'documents' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost', 'documents', documents)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}/{messageId}/Documents`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {GetPagedModuleMessagesQuery} [getPagedModuleMessagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdPagedPost: async (matrixModuleId: number, getPagedModuleMessagesQuery?: GetPagedModuleMessagesQuery, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdPagedPost', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}/Paged`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedModuleMessagesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} matrixModuleId 
         * @param {AddModuleMessageCommand} [addModuleMessageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdPost: async (matrixModuleId: string, addModuleMessageCommand?: AddModuleMessageCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'matrixModuleId' is not null or undefined
            assertParamExists('apiMatrixMessagesMatrixModuleIdPost', 'matrixModuleId', matrixModuleId)
            const localVarPath = `/api/MatrixMessages/{matrixModuleId}`
                .replace(`{${"matrixModuleId"}}`, encodeURIComponent(String(matrixModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addModuleMessageCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatrixMessagesApi - functional programming interface
 * @export
 */
export const MatrixMessagesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatrixMessagesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} [messageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdDelete(matrixModuleId: number, messageId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdDelete(matrixModuleId, messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdGet(matrixModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessagesWithUserResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdGet(matrixModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete(matrixModuleId: number, messageId: number, documentIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete(matrixModuleId, messageId, documentIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet(matrixModuleId: number, messageId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet(matrixModuleId, messageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet(matrixModuleId: number, messageId: number, idDocument: number, fileName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet(matrixModuleId, messageId, idDocument, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet(matrixModuleId: number, messageId: number, idDocument: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet(matrixModuleId, messageId, idDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(matrixModuleId: number, messageId: number, documents: Array<any>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(matrixModuleId, messageId, documents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {GetPagedModuleMessagesQuery} [getPagedModuleMessagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdPagedPost(matrixModuleId: number, getPagedModuleMessagesQuery?: GetPagedModuleMessagesQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageDtoPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdPagedPost(matrixModuleId, getPagedModuleMessagesQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} matrixModuleId 
         * @param {AddModuleMessageCommand} [addModuleMessageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixMessagesMatrixModuleIdPost(matrixModuleId: string, addModuleMessageCommand?: AddModuleMessageCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixMessagesMatrixModuleIdPost(matrixModuleId, addModuleMessageCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatrixMessagesApi - factory interface
 * @export
 */
export const MatrixMessagesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatrixMessagesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} [messageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdDelete(matrixModuleId: number, messageId?: number, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdDelete(matrixModuleId, messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdGet(matrixModuleId: number, options?: any): AxiosPromise<MessagesWithUserResult> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdGet(matrixModuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete(matrixModuleId: number, messageId: number, documentIds?: Array<number>, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete(matrixModuleId, messageId, documentIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet(matrixModuleId: number, messageId: number, options?: any): AxiosPromise<DocumentDtoListResult> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet(matrixModuleId, messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet(matrixModuleId: number, messageId: number, idDocument: number, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet(matrixModuleId, messageId, idDocument, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet(matrixModuleId: number, messageId: number, idDocument: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet(matrixModuleId, messageId, idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {number} messageId 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(matrixModuleId: number, messageId: number, documents: Array<any>, options?: any): AxiosPromise<DocumentListResult> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(matrixModuleId, messageId, documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} matrixModuleId 
         * @param {GetPagedModuleMessagesQuery} [getPagedModuleMessagesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdPagedPost(matrixModuleId: number, getPagedModuleMessagesQuery?: GetPagedModuleMessagesQuery, options?: any): AxiosPromise<MessageDtoPaginatedResult> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdPagedPost(matrixModuleId, getPagedModuleMessagesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} matrixModuleId 
         * @param {AddModuleMessageCommand} [addModuleMessageCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixMessagesMatrixModuleIdPost(matrixModuleId: string, addModuleMessageCommand?: AddModuleMessageCommand, options?: any): AxiosPromise<MessageResult> {
            return localVarFp.apiMatrixMessagesMatrixModuleIdPost(matrixModuleId, addModuleMessageCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatrixMessagesApi - object-oriented interface
 * @export
 * @class MatrixMessagesApi
 * @extends {BaseAPI}
 */
export class MatrixMessagesApi extends BaseAPI {
    /**
     * 
     * @param {number} matrixModuleId 
     * @param {number} [messageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdDelete(matrixModuleId: number, messageId?: number, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdDelete(matrixModuleId, messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdGet(matrixModuleId: number, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdGet(matrixModuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {number} messageId 
     * @param {Array<number>} [documentIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete(matrixModuleId: number, messageId: number, documentIds?: Array<number>, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdMessageIdDocumentsDelete(matrixModuleId, messageId, documentIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {number} messageId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet(matrixModuleId: number, messageId: number, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdMessageIdDocumentsGet(matrixModuleId, messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {number} messageId 
     * @param {number} idDocument 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet(matrixModuleId: number, messageId: number, idDocument: number, fileName: string, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentFileNameGet(matrixModuleId, messageId, idDocument, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {number} messageId 
     * @param {number} idDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet(matrixModuleId: number, messageId: number, idDocument: number, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdMessageIdDocumentsIdDocumentGet(matrixModuleId, messageId, idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {number} messageId 
     * @param {Array<any>} documents 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(matrixModuleId: number, messageId: number, documents: Array<any>, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdMessageIdDocumentsPost(matrixModuleId, messageId, documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} matrixModuleId 
     * @param {GetPagedModuleMessagesQuery} [getPagedModuleMessagesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdPagedPost(matrixModuleId: number, getPagedModuleMessagesQuery?: GetPagedModuleMessagesQuery, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdPagedPost(matrixModuleId, getPagedModuleMessagesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} matrixModuleId 
     * @param {AddModuleMessageCommand} [addModuleMessageCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixMessagesApi
     */
    public apiMatrixMessagesMatrixModuleIdPost(matrixModuleId: string, addModuleMessageCommand?: AddModuleMessageCommand, options?: any) {
        return MatrixMessagesApiFp(this.configuration).apiMatrixMessagesMatrixModuleIdPost(matrixModuleId, addModuleMessageCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * MatrixsApi - axios parameter creator
 * @export
 */
export const MatrixsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Remove product from MatrixItem (obsolate)
         * @param {number} [produtTypeId] 
         * @param {number} [matrixYear] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsDelete: async (produtTypeId?: number, matrixYear?: number, productIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (produtTypeId !== undefined) {
                localVarQueryParameter['produtTypeId'] = produtTypeId;
            }

            if (matrixYear !== undefined) {
                localVarQueryParameter['matrixYear'] = matrixYear;
            }

            if (productIds) {
                localVarQueryParameter['productIds'] = productIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ExportMatrixItemToExcelQuery} [exportMatrixItemToExcelQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsExportExcelPost: async (exportMatrixItemToExcelQuery?: ExportMatrixItemToExcelQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/ExportExcel`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(exportMatrixItemToExcelQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [productTypeId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsGetMatrixByProductTypeAndYearGet: async (productTypeId?: number, year?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/GetMatrixByProductTypeAndYear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productTypeId !== undefined) {
                localVarQueryParameter['productTypeId'] = productTypeId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List user in Filter=>Reponsive for the step
         * @param {number} [productTypeId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsGetMatrixResponsiveFilterUsersGet: async (productTypeId?: number, year?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/GetMatrixResponsiveFilterUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (productTypeId !== undefined) {
                localVarQueryParameter['productTypeId'] = productTypeId;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Permanently Delete MatrixItem
         * @param {Array<number>} [matrixItemIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsMatrixItemDelete: async (matrixItemIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/MatrixItem`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (matrixItemIds) {
                localVarQueryParameter['matrixItemIds'] = matrixItemIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary GetAllModuleByProductTypeQuery (Step 2: Add Modules , after user choose products to add)
         * @param {number} productTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsModuleByProductTypeProductTypeIdGet: async (productTypeId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'productTypeId' is not null or undefined
            assertParamExists('apiMatrixsModuleByProductTypeProductTypeIdGet', 'productTypeId', productTypeId)
            const localVarPath = `/api/Matrixs/ModuleByProductType/{productTypeId}`
                .replace(`{${"productTypeId"}}`, encodeURIComponent(String(productTypeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Paged Product in Matrix List
         * @param {GetPagedMatrixItemQuery} [getPagedMatrixItemQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsPagedPost: async (getPagedMatrixItemQuery?: GetPagedMatrixItemQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedMatrixItemQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add product to MatrixItem
         * @param {AddProductToMatrixCommand} [addProductToMatrixCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsPost: async (addProductToMatrixCommand?: AddProductToMatrixCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductToMatrixCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Paged Products can be Add to MatrixItem
         * @param {GetPagedProductsToAddMatrixQuery} [getPagedProductsToAddMatrixQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsProductPagedPost: async (getPagedProductsToAddMatrixQuery?: GetPagedProductsToAddMatrixQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/Product/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedProductsToAddMatrixQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SetLockMatrixLockCommand} [setLockMatrixLockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsSetLockPatch: async (setLockMatrixLockCommand?: SetLockMatrixLockCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Matrixs/SetLock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setLockMatrixLockCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MatrixsApi - functional programming interface
 * @export
 */
export const MatrixsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MatrixsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Remove product from MatrixItem (obsolate)
         * @param {number} [produtTypeId] 
         * @param {number} [matrixYear] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsDelete(produtTypeId?: number, matrixYear?: number, productIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsDelete(produtTypeId, matrixYear, productIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ExportMatrixItemToExcelQuery} [exportMatrixItemToExcelQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsExportExcelPost(exportMatrixItemToExcelQuery?: ExportMatrixItemToExcelQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsExportExcelPost(exportMatrixItemToExcelQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [productTypeId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsGetMatrixByProductTypeAndYearGet(productTypeId?: number, year?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsGetMatrixByProductTypeAndYearGet(productTypeId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary List user in Filter=>Reponsive for the step
         * @param {number} [productTypeId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsGetMatrixResponsiveFilterUsersGet(productTypeId?: number, year?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsGetMatrixResponsiveFilterUsersGet(productTypeId, year, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Permanently Delete MatrixItem
         * @param {Array<number>} [matrixItemIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsMatrixItemDelete(matrixItemIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsMatrixItemDelete(matrixItemIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary GetAllModuleByProductTypeQuery (Step 2: Add Modules , after user choose products to add)
         * @param {number} productTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsModuleByProductTypeProductTypeIdGet(productTypeId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsModuleByProductTypeProductTypeIdGet(productTypeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Paged Product in Matrix List
         * @param {GetPagedMatrixItemQuery} [getPagedMatrixItemQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsPagedPost(getPagedMatrixItemQuery?: GetPagedMatrixItemQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemDtoPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsPagedPost(getPagedMatrixItemQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add product to MatrixItem
         * @param {AddProductToMatrixCommand} [addProductToMatrixCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsPost(addProductToMatrixCommand?: AddProductToMatrixCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsPost(addProductToMatrixCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Paged Products can be Add to MatrixItem
         * @param {GetPagedProductsToAddMatrixQuery} [getPagedProductsToAddMatrixQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsProductPagedPost(getPagedProductsToAddMatrixQuery?: GetPagedProductsToAddMatrixQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsProductPagedPost(getPagedProductsToAddMatrixQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {SetLockMatrixLockCommand} [setLockMatrixLockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMatrixsSetLockPatch(setLockMatrixLockCommand?: SetLockMatrixLockCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMatrixsSetLockPatch(setLockMatrixLockCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MatrixsApi - factory interface
 * @export
 */
export const MatrixsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MatrixsApiFp(configuration)
    return {
        /**
         * 
         * @summary Remove product from MatrixItem (obsolate)
         * @param {number} [produtTypeId] 
         * @param {number} [matrixYear] 
         * @param {Array<number>} [productIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsDelete(produtTypeId?: number, matrixYear?: number, productIds?: Array<number>, options?: any): AxiosPromise<MatrixItemListResult> {
            return localVarFp.apiMatrixsDelete(produtTypeId, matrixYear, productIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ExportMatrixItemToExcelQuery} [exportMatrixItemToExcelQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsExportExcelPost(exportMatrixItemToExcelQuery?: ExportMatrixItemToExcelQuery, options?: any): AxiosPromise<void> {
            return localVarFp.apiMatrixsExportExcelPost(exportMatrixItemToExcelQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [productTypeId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsGetMatrixByProductTypeAndYearGet(productTypeId?: number, year?: number, options?: any): AxiosPromise<MatrixResult> {
            return localVarFp.apiMatrixsGetMatrixByProductTypeAndYearGet(productTypeId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List user in Filter=>Reponsive for the step
         * @param {number} [productTypeId] 
         * @param {number} [year] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsGetMatrixResponsiveFilterUsersGet(productTypeId?: number, year?: number, options?: any): AxiosPromise<UserDtoListResult> {
            return localVarFp.apiMatrixsGetMatrixResponsiveFilterUsersGet(productTypeId, year, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Permanently Delete MatrixItem
         * @param {Array<number>} [matrixItemIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsMatrixItemDelete(matrixItemIds?: Array<number>, options?: any): AxiosPromise<MatrixItemListResult> {
            return localVarFp.apiMatrixsMatrixItemDelete(matrixItemIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary GetAllModuleByProductTypeQuery (Step 2: Add Modules , after user choose products to add)
         * @param {number} productTypeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsModuleByProductTypeProductTypeIdGet(productTypeId: number, options?: any): AxiosPromise<ModuleListResult> {
            return localVarFp.apiMatrixsModuleByProductTypeProductTypeIdGet(productTypeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Paged Product in Matrix List
         * @param {GetPagedMatrixItemQuery} [getPagedMatrixItemQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsPagedPost(getPagedMatrixItemQuery?: GetPagedMatrixItemQuery, options?: any): AxiosPromise<MatrixItemDtoPaginatedResult> {
            return localVarFp.apiMatrixsPagedPost(getPagedMatrixItemQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add product to MatrixItem
         * @param {AddProductToMatrixCommand} [addProductToMatrixCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsPost(addProductToMatrixCommand?: AddProductToMatrixCommand, options?: any): AxiosPromise<MatrixItemListResult> {
            return localVarFp.apiMatrixsPost(addProductToMatrixCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Paged Products can be Add to MatrixItem
         * @param {GetPagedProductsToAddMatrixQuery} [getPagedProductsToAddMatrixQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsProductPagedPost(getPagedProductsToAddMatrixQuery?: GetPagedProductsToAddMatrixQuery, options?: any): AxiosPromise<ProductPaginatedResult> {
            return localVarFp.apiMatrixsProductPagedPost(getPagedProductsToAddMatrixQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SetLockMatrixLockCommand} [setLockMatrixLockCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMatrixsSetLockPatch(setLockMatrixLockCommand?: SetLockMatrixLockCommand, options?: any): AxiosPromise<BooleanResult> {
            return localVarFp.apiMatrixsSetLockPatch(setLockMatrixLockCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MatrixsApi - object-oriented interface
 * @export
 * @class MatrixsApi
 * @extends {BaseAPI}
 */
export class MatrixsApi extends BaseAPI {
    /**
     * 
     * @summary Remove product from MatrixItem (obsolate)
     * @param {number} [produtTypeId] 
     * @param {number} [matrixYear] 
     * @param {Array<number>} [productIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsDelete(produtTypeId?: number, matrixYear?: number, productIds?: Array<number>, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsDelete(produtTypeId, matrixYear, productIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ExportMatrixItemToExcelQuery} [exportMatrixItemToExcelQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsExportExcelPost(exportMatrixItemToExcelQuery?: ExportMatrixItemToExcelQuery, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsExportExcelPost(exportMatrixItemToExcelQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [productTypeId] 
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsGetMatrixByProductTypeAndYearGet(productTypeId?: number, year?: number, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsGetMatrixByProductTypeAndYearGet(productTypeId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List user in Filter=>Reponsive for the step
     * @param {number} [productTypeId] 
     * @param {number} [year] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsGetMatrixResponsiveFilterUsersGet(productTypeId?: number, year?: number, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsGetMatrixResponsiveFilterUsersGet(productTypeId, year, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Permanently Delete MatrixItem
     * @param {Array<number>} [matrixItemIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsMatrixItemDelete(matrixItemIds?: Array<number>, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsMatrixItemDelete(matrixItemIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary GetAllModuleByProductTypeQuery (Step 2: Add Modules , after user choose products to add)
     * @param {number} productTypeId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsModuleByProductTypeProductTypeIdGet(productTypeId: number, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsModuleByProductTypeProductTypeIdGet(productTypeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Paged Product in Matrix List
     * @param {GetPagedMatrixItemQuery} [getPagedMatrixItemQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsPagedPost(getPagedMatrixItemQuery?: GetPagedMatrixItemQuery, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsPagedPost(getPagedMatrixItemQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add product to MatrixItem
     * @param {AddProductToMatrixCommand} [addProductToMatrixCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsPost(addProductToMatrixCommand?: AddProductToMatrixCommand, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsPost(addProductToMatrixCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Paged Products can be Add to MatrixItem
     * @param {GetPagedProductsToAddMatrixQuery} [getPagedProductsToAddMatrixQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsProductPagedPost(getPagedProductsToAddMatrixQuery?: GetPagedProductsToAddMatrixQuery, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsProductPagedPost(getPagedProductsToAddMatrixQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SetLockMatrixLockCommand} [setLockMatrixLockCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MatrixsApi
     */
    public apiMatrixsSetLockPatch(setLockMatrixLockCommand?: SetLockMatrixLockCommand, options?: any) {
        return MatrixsApiFp(this.configuration).apiMatrixsSetLockPatch(setLockMatrixLockCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ModulesApi - axios parameter creator
 * @export
 */
export const ModulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiModulesIdGet', 'id', id)
            const localVarPath = `/api/Modules/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiModulesIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Modules/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedModulesQuery} [getPagedModulesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesPagedPost: async (getPagedModulesQuery?: GetPagedModulesQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Modules/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedModulesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditModuleCommand} [addEditModuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesPost: async (addEditModuleCommand?: AddEditModuleCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Modules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditModuleCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ModulesApi - functional programming interface
 * @export
 */
export const ModulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ModulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModulesIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModuleResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModulesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModulesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModulesIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedModulesQuery} [getPagedModulesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModulesPagedPost(getPagedModulesQuery?: GetPagedModulesQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ModulePaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModulesPagedPost(getPagedModulesQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditModuleCommand} [addEditModuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiModulesPost(addEditModuleCommand?: AddEditModuleCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiModulesPost(addEditModuleCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ModulesApi - factory interface
 * @export
 */
export const ModulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ModulesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesIdGet(id: number, options?: any): AxiosPromise<ModuleResult> {
            return localVarFp.apiModulesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiModulesIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedModulesQuery} [getPagedModulesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesPagedPost(getPagedModulesQuery?: GetPagedModulesQuery, options?: any): AxiosPromise<ModulePaginatedResult> {
            return localVarFp.apiModulesPagedPost(getPagedModulesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditModuleCommand} [addEditModuleCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiModulesPost(addEditModuleCommand?: AddEditModuleCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiModulesPost(addEditModuleCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ModulesApi - object-oriented interface
 * @export
 * @class ModulesApi
 * @extends {BaseAPI}
 */
export class ModulesApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public apiModulesIdGet(id: number, options?: any) {
        return ModulesApiFp(this.configuration).apiModulesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public apiModulesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return ModulesApiFp(this.configuration).apiModulesIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedModulesQuery} [getPagedModulesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public apiModulesPagedPost(getPagedModulesQuery?: GetPagedModulesQuery, options?: any) {
        return ModulesApiFp(this.configuration).apiModulesPagedPost(getPagedModulesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditModuleCommand} [addEditModuleCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ModulesApi
     */
    public apiModulesPost(addEditModuleCommand?: AddEditModuleCommand, options?: any) {
        return ModulesApiFp(this.configuration).apiModulesPost(addEditModuleCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsDeleteAllNotiDelete: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/DeleteAllNoti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGetCountNotOpenNotiGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/GetCountNotOpenNoti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGetCountUnReadNotiGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/GetCountUnReadNoti`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsMaskAllNotisIsReadPatch: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/MaskAllNotisIsRead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {MaskNotisIsReadCommand} [maskNotisIsReadCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsMaskNotisIsReadPatch: async (maskNotisIsReadCommand?: MaskNotisIsReadCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/MaskNotisIsRead`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(maskNotisIsReadCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedNotificationQuery} [getPagedNotificationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPagedPost: async (getPagedNotificationQuery?: GetPagedNotificationQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedNotificationQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsRunDeadlineDelete: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Notifications/RunDeadline`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsDeleteAllNotiDelete(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsDeleteAllNotiDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsGetCountNotOpenNotiGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsGetCountNotOpenNotiGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsGetCountUnReadNotiGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsGetCountUnReadNotiGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsMaskAllNotisIsReadPatch(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsMaskAllNotisIsReadPatch(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {MaskNotisIsReadCommand} [maskNotisIsReadCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsMaskNotisIsReadPatch(maskNotisIsReadCommand?: MaskNotisIsReadCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsMaskNotisIsReadPatch(maskNotisIsReadCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedNotificationQuery} [getPagedNotificationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsPagedPost(getPagedNotificationQuery?: GetPagedNotificationQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationDtoPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsPagedPost(getPagedNotificationQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiNotificationsRunDeadlineDelete(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MatrixItemModule>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiNotificationsRunDeadlineDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsDeleteAllNotiDelete(options?: any): AxiosPromise<number> {
            return localVarFp.apiNotificationsDeleteAllNotiDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGetCountNotOpenNotiGet(options?: any): AxiosPromise<number> {
            return localVarFp.apiNotificationsGetCountNotOpenNotiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsGetCountUnReadNotiGet(options?: any): AxiosPromise<number> {
            return localVarFp.apiNotificationsGetCountUnReadNotiGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsMaskAllNotisIsReadPatch(options?: any): AxiosPromise<number> {
            return localVarFp.apiNotificationsMaskAllNotisIsReadPatch(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {MaskNotisIsReadCommand} [maskNotisIsReadCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsMaskNotisIsReadPatch(maskNotisIsReadCommand?: MaskNotisIsReadCommand, options?: any): AxiosPromise<number> {
            return localVarFp.apiNotificationsMaskNotisIsReadPatch(maskNotisIsReadCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedNotificationQuery} [getPagedNotificationQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsPagedPost(getPagedNotificationQuery?: GetPagedNotificationQuery, options?: any): AxiosPromise<NotificationDtoPaginatedResult> {
            return localVarFp.apiNotificationsPagedPost(getPagedNotificationQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiNotificationsRunDeadlineDelete(options?: any): AxiosPromise<Array<MatrixItemModule>> {
            return localVarFp.apiNotificationsRunDeadlineDelete(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsDeleteAllNotiDelete(options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsDeleteAllNotiDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsGetCountNotOpenNotiGet(options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsGetCountNotOpenNotiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsGetCountUnReadNotiGet(options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsGetCountUnReadNotiGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsMaskAllNotisIsReadPatch(options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsMaskAllNotisIsReadPatch(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {MaskNotisIsReadCommand} [maskNotisIsReadCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsMaskNotisIsReadPatch(maskNotisIsReadCommand?: MaskNotisIsReadCommand, options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsMaskNotisIsReadPatch(maskNotisIsReadCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedNotificationQuery} [getPagedNotificationQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsPagedPost(getPagedNotificationQuery?: GetPagedNotificationQuery, options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsPagedPost(getPagedNotificationQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public apiNotificationsRunDeadlineDelete(options?: any) {
        return NotificationsApiFp(this.configuration).apiNotificationsRunDeadlineDelete(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductTypesApi - axios parameter creator
 * @export
 */
export const ProductTypesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductTypesIdGet', 'id', id)
            const localVarPath = `/api/ProductTypes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductTypesIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/ProductTypes/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedProductTypesQuery} [getPagedProductTypesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesPagedPost: async (getPagedProductTypesQuery?: GetPagedProductTypesQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductTypes/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedProductTypesQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditProductTypeCommand} [addEditProductTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesPost: async (addEditProductTypeCommand?: AddEditProductTypeCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ProductTypes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditProductTypeCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTypesApi - functional programming interface
 * @export
 */
export const ProductTypesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTypesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductTypesIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypeResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductTypesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductTypesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductTypesIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedProductTypesQuery} [getPagedProductTypesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductTypesPagedPost(getPagedProductTypesQuery?: GetPagedProductTypesQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductTypePaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductTypesPagedPost(getPagedProductTypesQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditProductTypeCommand} [addEditProductTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductTypesPost(addEditProductTypeCommand?: AddEditProductTypeCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductTypesPost(addEditProductTypeCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductTypesApi - factory interface
 * @export
 */
export const ProductTypesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTypesApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesIdGet(id: number, options?: any): AxiosPromise<ProductTypeResult> {
            return localVarFp.apiProductTypesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiProductTypesIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedProductTypesQuery} [getPagedProductTypesQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesPagedPost(getPagedProductTypesQuery?: GetPagedProductTypesQuery, options?: any): AxiosPromise<ProductTypePaginatedResult> {
            return localVarFp.apiProductTypesPagedPost(getPagedProductTypesQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditProductTypeCommand} [addEditProductTypeCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductTypesPost(addEditProductTypeCommand?: AddEditProductTypeCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiProductTypesPost(addEditProductTypeCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTypesApi - object-oriented interface
 * @export
 * @class ProductTypesApi
 * @extends {BaseAPI}
 */
export class ProductTypesApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTypesApi
     */
    public apiProductTypesIdGet(id: number, options?: any) {
        return ProductTypesApiFp(this.configuration).apiProductTypesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTypesApi
     */
    public apiProductTypesIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return ProductTypesApiFp(this.configuration).apiProductTypesIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedProductTypesQuery} [getPagedProductTypesQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTypesApi
     */
    public apiProductTypesPagedPost(getPagedProductTypesQuery?: GetPagedProductTypesQuery, options?: any) {
        return ProductTypesApiFp(this.configuration).apiProductTypesPagedPost(getPagedProductTypesQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditProductTypeCommand} [addEditProductTypeCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTypesApi
     */
    public apiProductTypesPost(addEditProductTypeCommand?: AddEditProductTypeCommand, options?: any) {
        return ProductTypesApiFp(this.configuration).apiProductTypesPost(addEditProductTypeCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProductsApi - axios parameter creator
 * @export
 */
export const ProductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Export Product
         * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsExportProductPost: async (getPagedProductsQuery?: GetPagedProductsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Products/ExportProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedProductsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary download template Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsExportTemplateProductPost: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Products/ExportTemplateProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Product By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductsIdGet', 'id', id)
            const localVarPath = `/api/Products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Product Active State
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiProductsIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Products/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary import Product
         * @param {boolean} [overrideIfDuplicated] 
         * @param {any} [formFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsImportProductPost: async (overrideIfDuplicated?: boolean, formFiles?: any, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Products/ImportProduct`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (overrideIfDuplicated !== undefined) {
                localVarQueryParameter['overrideIfDuplicated'] = overrideIfDuplicated;
            }


            if (formFiles !== undefined) { 
                localVarFormParams.append('formFiles', formFiles as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Paged Products
         * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsPagedPost: async (getPagedProductsQuery?: GetPagedProductsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Products/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedProductsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add/Edit a Product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsPost: async (productModel?: ProductModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProductSpecificationModel} [productSpecificationModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductSpecification: async (productSpecificationModel?: ProductSpecificationModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Products/Specification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(productSpecificationModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductsApi - functional programming interface
 * @export
 */
export const ProductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Export Product
         * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsExportProductPost(getPagedProductsQuery?: GetPagedProductsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsExportProductPost(getPagedProductsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary download template Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsExportTemplateProductPost(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsExportTemplateProductPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a Product By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductModelApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Product Active State
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary import Product
         * @param {boolean} [overrideIfDuplicated] 
         * @param {any} [formFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsImportProductPost(overrideIfDuplicated?: boolean, formFiles?: any, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportExcelResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsImportProductPost(overrideIfDuplicated, formFiles, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Paged Products
         * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsPagedPost(getPagedProductsQuery?: GetPagedProductsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProductModelIEnumerableApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsPagedPost(getPagedProductsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add/Edit a Product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiProductsPost(productModel?: ProductModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32ApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiProductsPost(productModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ProductSpecificationModel} [productSpecificationModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProductSpecification(productSpecificationModel?: ProductSpecificationModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanApiResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProductSpecification(productSpecificationModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductsApi - factory interface
 * @export
 */
export const ProductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductsApiFp(configuration)
    return {
        /**
         * 
         * @summary Export Product
         * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsExportProductPost(getPagedProductsQuery?: GetPagedProductsQuery, options?: any): AxiosPromise<void> {
            return localVarFp.apiProductsExportProductPost(getPagedProductsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary download template Product
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsExportTemplateProductPost(options?: any): AxiosPromise<void> {
            return localVarFp.apiProductsExportTemplateProductPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Product By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdGet(id: number, options?: any): AxiosPromise<ProductModelApiResponse> {
            return localVarFp.apiProductsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Product Active State
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiProductsIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary import Product
         * @param {boolean} [overrideIfDuplicated] 
         * @param {any} [formFiles] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsImportProductPost(overrideIfDuplicated?: boolean, formFiles?: any, options?: any): AxiosPromise<ImportExcelResponse> {
            return localVarFp.apiProductsImportProductPost(overrideIfDuplicated, formFiles, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Paged Products
         * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsPagedPost(getPagedProductsQuery?: GetPagedProductsQuery, options?: any): AxiosPromise<ProductModelIEnumerableApiResponse> {
            return localVarFp.apiProductsPagedPost(getPagedProductsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add/Edit a Product
         * @param {ProductModel} [productModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiProductsPost(productModel?: ProductModel, options?: any): AxiosPromise<Int32ApiResponse> {
            return localVarFp.apiProductsPost(productModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ProductSpecificationModel} [productSpecificationModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProductSpecification(productSpecificationModel?: ProductSpecificationModel, options?: any): AxiosPromise<BooleanApiResponse> {
            return localVarFp.updateProductSpecification(productSpecificationModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductsApi - object-oriented interface
 * @export
 * @class ProductsApi
 * @extends {BaseAPI}
 */
export class ProductsApi extends BaseAPI {
    /**
     * 
     * @summary Export Product
     * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsExportProductPost(getPagedProductsQuery?: GetPagedProductsQuery, options?: any) {
        return ProductsApiFp(this.configuration).apiProductsExportProductPost(getPagedProductsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary download template Product
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsExportTemplateProductPost(options?: any) {
        return ProductsApiFp(this.configuration).apiProductsExportTemplateProductPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Product By Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsIdGet(id: number, options?: any) {
        return ProductsApiFp(this.configuration).apiProductsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Product Active State
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return ProductsApiFp(this.configuration).apiProductsIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary import Product
     * @param {boolean} [overrideIfDuplicated] 
     * @param {any} [formFiles] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsImportProductPost(overrideIfDuplicated?: boolean, formFiles?: any, options?: any) {
        return ProductsApiFp(this.configuration).apiProductsImportProductPost(overrideIfDuplicated, formFiles, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Paged Products
     * @param {GetPagedProductsQuery} [getPagedProductsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsPagedPost(getPagedProductsQuery?: GetPagedProductsQuery, options?: any) {
        return ProductsApiFp(this.configuration).apiProductsPagedPost(getPagedProductsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add/Edit a Product
     * @param {ProductModel} [productModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public apiProductsPost(productModel?: ProductModel, options?: any) {
        return ProductsApiFp(this.configuration).apiProductsPost(productModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ProductSpecificationModel} [productSpecificationModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductsApi
     */
    public updateProductSpecification(productSpecificationModel?: ProductSpecificationModel, options?: any) {
        return ProductsApiFp(this.configuration).updateProductSpecification(productSpecificationModel, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoleApi - axios parameter creator
 * @export
 */
export const RoleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All Roles (basic, admin etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Permissions By Role Id
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolePermissionsRoleIdGet: async (roleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiIdentityRolePermissionsRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/identity/role/permissions/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit a Role Claim
         * @param {PermissionRequest} [permissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolePermissionsUpdatePut: async (permissionRequest?: PermissionRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/role/permissions/update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(permissionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a Role
         * @param {RoleRequest} [roleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolePost: async (roleRequest?: RoleRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All Roles (basic, admin etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRoleGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponseListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRoleGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Permissions By Role Id
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolePermissionsRoleIdGet(roleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PermissionResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolePermissionsRoleIdGet(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Edit a Role Claim
         * @param {PermissionRequest} [permissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolePermissionsUpdatePut(permissionRequest?: PermissionRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolePermissionsUpdatePut(permissionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a Role
         * @param {RoleRequest} [roleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRolePost(roleRequest?: RoleRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRolePost(roleRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All Roles (basic, admin etc.)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleGet(options?: any): AxiosPromise<RoleResponseListResult> {
            return localVarFp.apiIdentityRoleGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Permissions By Role Id
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolePermissionsRoleIdGet(roleId: number, options?: any): AxiosPromise<PermissionResponseResult> {
            return localVarFp.apiIdentityRolePermissionsRoleIdGet(roleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit a Role Claim
         * @param {PermissionRequest} [permissionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolePermissionsUpdatePut(permissionRequest?: PermissionRequest, options?: any): AxiosPromise<StringResult> {
            return localVarFp.apiIdentityRolePermissionsUpdatePut(permissionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a Role
         * @param {RoleRequest} [roleRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRolePost(roleRequest?: RoleRequest, options?: any): AxiosPromise<StringResult> {
            return localVarFp.apiIdentityRolePost(roleRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     * 
     * @summary Get All Roles (basic, admin etc.)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRoleGet(options?: any) {
        return RoleApiFp(this.configuration).apiIdentityRoleGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Permissions By Role Id
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolePermissionsRoleIdGet(roleId: number, options?: any) {
        return RoleApiFp(this.configuration).apiIdentityRolePermissionsRoleIdGet(roleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit a Role Claim
     * @param {PermissionRequest} [permissionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolePermissionsUpdatePut(permissionRequest?: PermissionRequest, options?: any) {
        return RoleApiFp(this.configuration).apiIdentityRolePermissionsUpdatePut(permissionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a Role
     * @param {RoleRequest} [roleRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    public apiIdentityRolePost(roleRequest?: RoleRequest, options?: any) {
        return RoleApiFp(this.configuration).apiIdentityRolePost(roleRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * RoleClaimApi - axios parameter creator
 * @export
 */
export const RoleClaimApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get All Role Claims(e.g. Product Create Permission)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleClaimGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roleClaim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a Role Claim
         * @param {RoleClaimRequest} [roleClaimRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleClaimPost: async (roleClaimRequest?: RoleClaimRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/roleClaim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleClaimRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get All Role Claims By Id
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleClaimRoleIdGet: async (roleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('apiIdentityRoleClaimRoleIdGet', 'roleId', roleId)
            const localVarPath = `/api/identity/roleClaim/{roleId}`
                .replace(`{${"roleId"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RoleClaimApi - functional programming interface
 * @export
 */
export const RoleClaimApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RoleClaimApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get All Role Claims(e.g. Product Create Permission)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRoleClaimGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleClaimResponseListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRoleClaimGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a Role Claim
         * @param {RoleClaimRequest} [roleClaimRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRoleClaimPost(roleClaimRequest?: RoleClaimRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRoleClaimPost(roleClaimRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get All Role Claims By Id
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityRoleClaimRoleIdGet(roleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleClaimResponseListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityRoleClaimRoleIdGet(roleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * RoleClaimApi - factory interface
 * @export
 */
export const RoleClaimApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RoleClaimApiFp(configuration)
    return {
        /**
         * 
         * @summary Get All Role Claims(e.g. Product Create Permission)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleClaimGet(options?: any): AxiosPromise<RoleClaimResponseListResult> {
            return localVarFp.apiIdentityRoleClaimGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a Role Claim
         * @param {RoleClaimRequest} [roleClaimRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleClaimPost(roleClaimRequest?: RoleClaimRequest, options?: any): AxiosPromise<StringResult> {
            return localVarFp.apiIdentityRoleClaimPost(roleClaimRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get All Role Claims By Id
         * @param {number} roleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityRoleClaimRoleIdGet(roleId: number, options?: any): AxiosPromise<RoleClaimResponseListResult> {
            return localVarFp.apiIdentityRoleClaimRoleIdGet(roleId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RoleClaimApi - object-oriented interface
 * @export
 * @class RoleClaimApi
 * @extends {BaseAPI}
 */
export class RoleClaimApi extends BaseAPI {
    /**
     * 
     * @summary Get All Role Claims(e.g. Product Create Permission)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleClaimApi
     */
    public apiIdentityRoleClaimGet(options?: any) {
        return RoleClaimApiFp(this.configuration).apiIdentityRoleClaimGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a Role Claim
     * @param {RoleClaimRequest} [roleClaimRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleClaimApi
     */
    public apiIdentityRoleClaimPost(roleClaimRequest?: RoleClaimRequest, options?: any) {
        return RoleClaimApiFp(this.configuration).apiIdentityRoleClaimPost(roleClaimRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get All Role Claims By Id
     * @param {number} roleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleClaimApi
     */
    public apiIdentityRoleClaimRoleIdGet(roleId: number, options?: any) {
        return RoleClaimApiFp(this.configuration).apiIdentityRoleClaimRoleIdGet(roleId, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SallingGroupUserApi - axios parameter creator
 * @export
 */
export const SallingGroupUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EditSallingGroupUserCommand} [editSallingGroupUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSallingGroupUserEditPatch: async (editSallingGroupUserCommand?: EditSallingGroupUserCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SallingGroupUser/Edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editSallingGroupUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSallingGroupUserIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiSallingGroupUserIdGet', 'id', id)
            const localVarPath = `/api/SallingGroupUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SallingGroupUserApi - functional programming interface
 * @export
 */
export const SallingGroupUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SallingGroupUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EditSallingGroupUserCommand} [editSallingGroupUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSallingGroupUserEditPatch(editSallingGroupUserCommand?: EditSallingGroupUserCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserSallingGroup>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSallingGroupUserEditPatch(editSallingGroupUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSallingGroupUserIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SgUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSallingGroupUserIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SallingGroupUserApi - factory interface
 * @export
 */
export const SallingGroupUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SallingGroupUserApiFp(configuration)
    return {
        /**
         * 
         * @param {EditSallingGroupUserCommand} [editSallingGroupUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSallingGroupUserEditPatch(editSallingGroupUserCommand?: EditSallingGroupUserCommand, options?: any): AxiosPromise<UserSallingGroup> {
            return localVarFp.apiSallingGroupUserEditPatch(editSallingGroupUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSallingGroupUserIdGet(id: number, options?: any): AxiosPromise<SgUserDto> {
            return localVarFp.apiSallingGroupUserIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SallingGroupUserApi - object-oriented interface
 * @export
 * @class SallingGroupUserApi
 * @extends {BaseAPI}
 */
export class SallingGroupUserApi extends BaseAPI {
    /**
     * 
     * @param {EditSallingGroupUserCommand} [editSallingGroupUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SallingGroupUserApi
     */
    public apiSallingGroupUserEditPatch(editSallingGroupUserCommand?: EditSallingGroupUserCommand, options?: any) {
        return SallingGroupUserApiFp(this.configuration).apiSallingGroupUserEditPatch(editSallingGroupUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SallingGroupUserApi
     */
    public apiSallingGroupUserIdGet(id: number, options?: any) {
        return SallingGroupUserApiFp(this.configuration).apiSallingGroupUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SystemConfigsApi - axios parameter creator
 * @export
 */
export const SystemConfigsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigsGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemConfigs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EditSystemConfigCommand} [editSystemConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigsPost: async (editSystemConfigCommand?: EditSystemConfigCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/SystemConfigs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editSystemConfigCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemConfigsApi - functional programming interface
 * @export
 */
export const SystemConfigsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemConfigsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemConfigsGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SystemConfigResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemConfigsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {EditSystemConfigCommand} [editSystemConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiSystemConfigsPost(editSystemConfigCommand?: EditSystemConfigCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiSystemConfigsPost(editSystemConfigCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SystemConfigsApi - factory interface
 * @export
 */
export const SystemConfigsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemConfigsApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigsGet(options?: any): AxiosPromise<SystemConfigResult> {
            return localVarFp.apiSystemConfigsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EditSystemConfigCommand} [editSystemConfigCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiSystemConfigsPost(editSystemConfigCommand?: EditSystemConfigCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiSystemConfigsPost(editSystemConfigCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemConfigsApi - object-oriented interface
 * @export
 * @class SystemConfigsApi
 * @extends {BaseAPI}
 */
export class SystemConfigsApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemConfigsApi
     */
    public apiSystemConfigsGet(options?: any) {
        return SystemConfigsApiFp(this.configuration).apiSystemConfigsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EditSystemConfigCommand} [editSystemConfigCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemConfigsApi
     */
    public apiSystemConfigsPost(editSystemConfigCommand?: EditSystemConfigCommand, options?: any) {
        return SystemConfigsApiFp(this.configuration).apiSystemConfigsPost(editSystemConfigCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestDocumentsApi - axios parameter creator
 * @export
 */
export const TestDocumentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdDelete: async (id: number, documentIds?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestDocumentsIdDelete', 'id', id)
            const localVarPath = `/api/TestDocuments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documentIds) {
                localVarQueryParameter['documentIds'] = documentIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestDocumentsIdGet', 'id', id)
            const localVarPath = `/api/TestDocuments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get test document by documentId and file name
         * @param {number} id 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdIdDocumentFileNameGet: async (id: number, idDocument: number, fileName: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestDocumentsIdIdDocumentFileNameGet', 'id', id)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiTestDocumentsIdIdDocumentFileNameGet', 'idDocument', idDocument)
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('apiTestDocumentsIdIdDocumentFileNameGet', 'fileName', fileName)
            const localVarPath = `/api/TestDocuments/{id}/{idDocument}/{fileName}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)))
                .replace(`{${"fileName"}}`, encodeURIComponent(String(fileName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get test document by documentId
         * @param {number} id 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdIdDocumentGet: async (id: number, idDocument: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestDocumentsIdIdDocumentGet', 'id', id)
            // verify required parameter 'idDocument' is not null or undefined
            assertParamExists('apiTestDocumentsIdIdDocumentGet', 'idDocument', idDocument)
            const localVarPath = `/api/TestDocuments/{id}/{idDocument}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"idDocument"}}`, encodeURIComponent(String(idDocument)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdPost: async (id: number, documents: Array<any>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestDocumentsIdPost', 'id', id)
            // verify required parameter 'documents' is not null or undefined
            assertParamExists('apiTestDocumentsIdPost', 'documents', documents)
            const localVarPath = `/api/TestDocuments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (documents) {
                documents.forEach((element) => {
                    localVarFormParams.append('documents', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zip test document and download
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdZipGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestDocumentsIdZipGet', 'id', id)
            const localVarPath = `/api/TestDocuments/{id}/Zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestDocumentsApi - functional programming interface
 * @export
 */
export const TestDocumentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestDocumentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDocumentsIdDelete(id: number, documentIds?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDocumentsIdDelete(id, documentIds, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDocumentsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentDtoListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDocumentsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get test document by documentId and file name
         * @param {number} id 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDocumentsIdIdDocumentFileNameGet(id: number, idDocument: number, fileName: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDocumentsIdIdDocumentFileNameGet(id, idDocument, fileName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get test document by documentId
         * @param {number} id 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDocumentsIdIdDocumentGet(id: number, idDocument: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDocumentsIdIdDocumentGet(id, idDocument, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDocumentsIdPost(id: number, documents: Array<any>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DocumentListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDocumentsIdPost(id, documents, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Zip test document and download
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestDocumentsIdZipGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestDocumentsIdZipGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestDocumentsApi - factory interface
 * @export
 */
export const TestDocumentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestDocumentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} id 
         * @param {Array<number>} [documentIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdDelete(id: number, documentIds?: Array<number>, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiTestDocumentsIdDelete(id, documentIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdGet(id: number, options?: any): AxiosPromise<DocumentDtoListResult> {
            return localVarFp.apiTestDocumentsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get test document by documentId and file name
         * @param {number} id 
         * @param {number} idDocument 
         * @param {string} fileName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdIdDocumentFileNameGet(id: number, idDocument: number, fileName: string, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestDocumentsIdIdDocumentFileNameGet(id, idDocument, fileName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get test document by documentId
         * @param {number} id 
         * @param {number} idDocument 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdIdDocumentGet(id: number, idDocument: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestDocumentsIdIdDocumentGet(id, idDocument, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {Array<any>} documents 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdPost(id: number, documents: Array<any>, options?: any): AxiosPromise<DocumentListResult> {
            return localVarFp.apiTestDocumentsIdPost(id, documents, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zip test document and download
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestDocumentsIdZipGet(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestDocumentsIdZipGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestDocumentsApi - object-oriented interface
 * @export
 * @class TestDocumentsApi
 * @extends {BaseAPI}
 */
export class TestDocumentsApi extends BaseAPI {
    /**
     * 
     * @param {number} id 
     * @param {Array<number>} [documentIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDocumentsApi
     */
    public apiTestDocumentsIdDelete(id: number, documentIds?: Array<number>, options?: any) {
        return TestDocumentsApiFp(this.configuration).apiTestDocumentsIdDelete(id, documentIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDocumentsApi
     */
    public apiTestDocumentsIdGet(id: number, options?: any) {
        return TestDocumentsApiFp(this.configuration).apiTestDocumentsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get test document by documentId and file name
     * @param {number} id 
     * @param {number} idDocument 
     * @param {string} fileName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDocumentsApi
     */
    public apiTestDocumentsIdIdDocumentFileNameGet(id: number, idDocument: number, fileName: string, options?: any) {
        return TestDocumentsApiFp(this.configuration).apiTestDocumentsIdIdDocumentFileNameGet(id, idDocument, fileName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get test document by documentId
     * @param {number} id 
     * @param {number} idDocument 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDocumentsApi
     */
    public apiTestDocumentsIdIdDocumentGet(id: number, idDocument: number, options?: any) {
        return TestDocumentsApiFp(this.configuration).apiTestDocumentsIdIdDocumentGet(id, idDocument, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {Array<any>} documents 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDocumentsApi
     */
    public apiTestDocumentsIdPost(id: number, documents: Array<any>, options?: any) {
        return TestDocumentsApiFp(this.configuration).apiTestDocumentsIdPost(id, documents, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zip test document and download
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestDocumentsApi
     */
    public apiTestDocumentsIdZipGet(id: number, options?: any) {
        return TestDocumentsApiFp(this.configuration).apiTestDocumentsIdZipGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TestsApi - axios parameter creator
 * @export
 */
export const TestsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {AssignedProductRequestModel} [assignedProductRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdAssignProductsPagedPost: async (id: string, assignedProductRequestModel?: AssignedProductRequestModel, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdAssignProductsPagedPost', 'id', id)
            const localVarPath = `/api/Tests/{id}/AssignProductsPaged`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignedProductRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {AssignTestToProductsCommand} [assignTestToProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdAssignTestToProductsPost: async (id: string, assignTestToProductsCommand?: AssignTestToProductsCommand, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdAssignTestToProductsPost', 'id', id)
            const localVarPath = `/api/Tests/{id}/AssignTestToProducts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assignTestToProductsCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdGet', 'id', id)
            const localVarPath = `/api/Tests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {GetProductsCanBeAssignToTestQuery} [getProductsCanBeAssignToTestQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdProductsCanBeAssignToTestPost: async (id: number, getProductsCanBeAssignToTestQuery?: GetProductsCanBeAssignToTestQuery, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdProductsCanBeAssignToTestPost', 'id', id)
            const localVarPath = `/api/Tests/{id}/ProductsCanBeAssignToTest`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getProductsCanBeAssignToTestQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete: async (id: number, matrixItemModuleId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete', 'id', id)
            // verify required parameter 'matrixItemModuleId' is not null or undefined
            assertParamExists('apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete', 'matrixItemModuleId', matrixItemModuleId)
            const localVarPath = `/api/Tests/{id}/RemoveProductFromTest/{matrixItemModuleId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"matrixItemModuleId"}}`, encodeURIComponent(String(matrixItemModuleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isApproved] 
         * @param {boolean} [updateRelevantModules] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdSetApprovedPatch: async (id: number, isApproved?: boolean, updateRelevantModules?: boolean, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdSetApprovedPatch', 'id', id)
            const localVarPath = `/api/Tests/{id}/SetApproved`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (isApproved !== undefined) {
                localVarQueryParameter['isApproved'] = isApproved;
            }

            if (updateRelevantModules !== undefined) {
                localVarQueryParameter['updateRelevantModules'] = updateRelevantModules;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiTestsIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Tests/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedTestsQuery} [getPagedTestsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsPagedPost: async (getPagedTestsQuery?: GetPagedTestsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tests/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedTestsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditTestCommand} [addEditTestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsPost: async (addEditTestCommand?: AddEditTestCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Tests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditTestCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TestsApi - functional programming interface
 * @export
 */
export const TestsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TestsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AssignedProductRequestModel} [assignedProductRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdAssignProductsPagedPost(id: string, assignedProductRequestModel?: AssignedProductRequestModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssignedProductModelPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdAssignProductsPagedPost(id, assignedProductRequestModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {AssignTestToProductsCommand} [assignTestToProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdAssignTestToProductsPost(id: string, assignTestToProductsCommand?: AssignTestToProductsCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemModuleListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdAssignTestToProductsPost(id, assignTestToProductsCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestDtoResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {GetProductsCanBeAssignToTestQuery} [getProductsCanBeAssignToTestQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdProductsCanBeAssignToTestPost(id: number, getProductsCanBeAssignToTestQuery?: GetProductsCanBeAssignToTestQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MatrixItemModuleListResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdProductsCanBeAssignToTestPost(id, getProductsCanBeAssignToTestQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete(id: number, matrixItemModuleId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete(id, matrixItemModuleId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isApproved] 
         * @param {boolean} [updateRelevantModules] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdSetApprovedPatch(id: number, isApproved?: boolean, updateRelevantModules?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdSetApprovedPatch(id, isApproved, updateRelevantModules, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedTestsQuery} [getPagedTestsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsPagedPost(getPagedTestsQuery?: GetPagedTestsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TestPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsPagedPost(getPagedTestsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditTestCommand} [addEditTestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiTestsPost(addEditTestCommand?: AddEditTestCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiTestsPost(addEditTestCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TestsApi - factory interface
 * @export
 */
export const TestsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TestsApiFp(configuration)
    return {
        /**
         * 
         * @param {string} id 
         * @param {AssignedProductRequestModel} [assignedProductRequestModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdAssignProductsPagedPost(id: string, assignedProductRequestModel?: AssignedProductRequestModel, options?: any): AxiosPromise<AssignedProductModelPaginatedResult> {
            return localVarFp.apiTestsIdAssignProductsPagedPost(id, assignedProductRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {AssignTestToProductsCommand} [assignTestToProductsCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdAssignTestToProductsPost(id: string, assignTestToProductsCommand?: AssignTestToProductsCommand, options?: any): AxiosPromise<MatrixItemModuleListResult> {
            return localVarFp.apiTestsIdAssignTestToProductsPost(id, assignTestToProductsCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdGet(id: number, options?: any): AxiosPromise<TestDtoResult> {
            return localVarFp.apiTestsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {GetProductsCanBeAssignToTestQuery} [getProductsCanBeAssignToTestQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdProductsCanBeAssignToTestPost(id: number, getProductsCanBeAssignToTestQuery?: GetProductsCanBeAssignToTestQuery, options?: any): AxiosPromise<MatrixItemModuleListResult> {
            return localVarFp.apiTestsIdProductsCanBeAssignToTestPost(id, getProductsCanBeAssignToTestQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {number} matrixItemModuleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete(id: number, matrixItemModuleId: number, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete(id, matrixItemModuleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {boolean} [isApproved] 
         * @param {boolean} [updateRelevantModules] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdSetApprovedPatch(id: number, isApproved?: boolean, updateRelevantModules?: boolean, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiTestsIdSetApprovedPatch(id, isApproved, updateRelevantModules, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiTestsIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedTestsQuery} [getPagedTestsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsPagedPost(getPagedTestsQuery?: GetPagedTestsQuery, options?: any): AxiosPromise<TestPaginatedResult> {
            return localVarFp.apiTestsPagedPost(getPagedTestsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditTestCommand} [addEditTestCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiTestsPost(addEditTestCommand?: AddEditTestCommand, options?: any): AxiosPromise<void> {
            return localVarFp.apiTestsPost(addEditTestCommand, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TestsApi - object-oriented interface
 * @export
 * @class TestsApi
 * @extends {BaseAPI}
 */
export class TestsApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {AssignedProductRequestModel} [assignedProductRequestModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdAssignProductsPagedPost(id: string, assignedProductRequestModel?: AssignedProductRequestModel, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdAssignProductsPagedPost(id, assignedProductRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {AssignTestToProductsCommand} [assignTestToProductsCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdAssignTestToProductsPost(id: string, assignTestToProductsCommand?: AssignTestToProductsCommand, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdAssignTestToProductsPost(id, assignTestToProductsCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdGet(id: number, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {GetProductsCanBeAssignToTestQuery} [getProductsCanBeAssignToTestQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdProductsCanBeAssignToTestPost(id: number, getProductsCanBeAssignToTestQuery?: GetProductsCanBeAssignToTestQuery, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdProductsCanBeAssignToTestPost(id, getProductsCanBeAssignToTestQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {number} matrixItemModuleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete(id: number, matrixItemModuleId: number, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdRemoveProductFromTestMatrixItemModuleIdDelete(id, matrixItemModuleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {boolean} [isApproved] 
     * @param {boolean} [updateRelevantModules] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdSetApprovedPatch(id: number, isApproved?: boolean, updateRelevantModules?: boolean, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdSetApprovedPatch(id, isApproved, updateRelevantModules, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return TestsApiFp(this.configuration).apiTestsIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedTestsQuery} [getPagedTestsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsPagedPost(getPagedTestsQuery?: GetPagedTestsQuery, options?: any) {
        return TestsApiFp(this.configuration).apiTestsPagedPost(getPagedTestsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditTestCommand} [addEditTestCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestsApi
     */
    public apiTestsPost(addEditTestCommand?: AddEditTestCommand, options?: any) {
        return TestsApiFp(this.configuration).apiTestsPost(addEditTestCommand, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Token from token azure
         * @param {LoginFromAzureRequest} [loginFromAzureRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenLoginFromAzurePost: async (loginFromAzureRequest?: LoginFromAzureRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/token/LoginFromAzure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginFromAzureRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Token (Email, Password)
         * @param {TokenRequest} [tokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenPost: async (tokenRequest?: TokenRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tokenRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {string} [deviceToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenRemoveDeviceTokensDelete: async (userId?: number, deviceToken?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/token/RemoveDeviceTokens`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (deviceToken !== undefined) {
                localVarQueryParameter['deviceToken'] = deviceToken;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenUserDetailGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/identity/token/UserDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Token from token azure
         * @param {LoginFromAzureRequest} [loginFromAzureRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityTokenLoginFromAzurePost(loginFromAzureRequest?: LoginFromAzureRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityTokenLoginFromAzurePost(loginFromAzureRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Token (Email, Password)
         * @param {TokenRequest} [tokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityTokenPost(tokenRequest?: TokenRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponseResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityTokenPost(tokenRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {string} [deviceToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityTokenRemoveDeviceTokensDelete(userId?: number, deviceToken?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityTokenRemoveDeviceTokensDelete(userId, deviceToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get User Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIdentityTokenUserDetailGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIdentityTokenUserDetailGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Token from token azure
         * @param {LoginFromAzureRequest} [loginFromAzureRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenLoginFromAzurePost(loginFromAzureRequest?: LoginFromAzureRequest, options?: any): AxiosPromise<TokenResponseResult> {
            return localVarFp.apiIdentityTokenLoginFromAzurePost(loginFromAzureRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Token (Email, Password)
         * @param {TokenRequest} [tokenRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenPost(tokenRequest?: TokenRequest, options?: any): AxiosPromise<TokenResponseResult> {
            return localVarFp.apiIdentityTokenPost(tokenRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [userId] 
         * @param {string} [deviceToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenRemoveDeviceTokensDelete(userId?: number, deviceToken?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiIdentityTokenRemoveDeviceTokensDelete(userId, deviceToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Details
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIdentityTokenUserDetailGet(options?: any): AxiosPromise<UserResponse> {
            return localVarFp.apiIdentityTokenUserDetailGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI {
    /**
     * 
     * @summary Get Token from token azure
     * @param {LoginFromAzureRequest} [loginFromAzureRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public apiIdentityTokenLoginFromAzurePost(loginFromAzureRequest?: LoginFromAzureRequest, options?: any) {
        return TokenApiFp(this.configuration).apiIdentityTokenLoginFromAzurePost(loginFromAzureRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Token (Email, Password)
     * @param {TokenRequest} [tokenRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public apiIdentityTokenPost(tokenRequest?: TokenRequest, options?: any) {
        return TokenApiFp(this.configuration).apiIdentityTokenPost(tokenRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [userId] 
     * @param {string} [deviceToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public apiIdentityTokenRemoveDeviceTokensDelete(userId?: number, deviceToken?: string, options?: any) {
        return TokenApiFp(this.configuration).apiIdentityTokenRemoveDeviceTokensDelete(userId, deviceToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Details
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public apiIdentityTokenUserDetailGet(options?: any) {
        return TokenApiFp(this.configuration).apiIdentityTokenUserDetailGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary change Password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChangePasswordPost: async (changePasswordRequest?: ChangePasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/ChangePassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Confirm Email
         * @param {number} [userId] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfirmEmailGet: async (userId?: number, code?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/confirm-email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit User
         * @param {EditUserCommand} [editUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserEditUserPost: async (editUserCommand?: EditUserCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/EditUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Forgot Password
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserForgotPasswordPost: async (email?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/forgot-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetCurrentUserManagedVendorGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/GetCurrentUserManagedVendor`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetCurrentUserProductTypeGet: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/GetCurrentUserProductType`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserIdGet', 'id', id)
            const localVarPath = `/api/User/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedUserQuery} [getPagedUserQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPagedPost: async (getPagedUserQuery?: GetPagedUserQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedUserQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register User
         * @param {RegisterUserCommand} [registerUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost: async (registerUserCommand?: RegisterUserCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary reset password
         * @param {number} id 
         * @param {string} [password] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserResetPasswordPasswordGet: async (id: number, password?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserResetPasswordPasswordGet', 'id', id)
            const localVarPath = `/api/User/reset-password/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (password !== undefined) {
                localVarQueryParameter['password'] = password;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset Password
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserResetPasswordPost: async (resetPasswordRequest?: ResetPasswordRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User Roles By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRolesIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserRolesIdGet', 'id', id)
            const localVarPath = `/api/User/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Roles for User
         * @param {string} id 
         * @param {UpdateUserRolesRequest} [updateUserRolesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRolesIdPut: async (id: string, updateUserRolesRequest?: UpdateUserRolesRequest, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiUserRolesIdPut', 'id', id)
            const localVarPath = `/api/User/roles/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserRolesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change state User
         * @param {SetStatesUserCommand} [setStatesUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSetStatesPatch: async (setStatesUserCommand?: SetStatesUserCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/SetStates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setStatesUserCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Toggle User Status (Activate and Deactivate)
         * @param {ToggleUserStatusRequest} [toggleUserStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserToggleStatusPost: async (toggleUserStatusRequest?: ToggleUserStatusRequest, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/User/toggle-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleUserStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary change Password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserChangePasswordPost(changePasswordRequest?: ChangePasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserChangePasswordPost(changePasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Confirm Email
         * @param {number} [userId] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserConfirmEmailGet(userId?: number, code?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringIResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserConfirmEmailGet(userId, code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Edit User
         * @param {EditUserCommand} [editUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserEditUserPost(editUserCommand?: EditUserCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserEditUserPost(editUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Forgot Password
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserForgotPasswordPost(email?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserForgotPasswordPost(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGetCurrentUserManagedVendorGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Vendor>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGetCurrentUserManagedVendorGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserGetCurrentUserProductTypeGet(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ProductType>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserGetCurrentUserProductTypeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get User By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseIResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedUserQuery} [getPagedUserQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPagedPost(getPagedUserQuery?: GetPagedUserQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDtoPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPagedPost(getPagedUserQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register User
         * @param {RegisterUserCommand} [registerUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserPost(registerUserCommand?: RegisterUserCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserPost(registerUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary reset password
         * @param {number} id 
         * @param {string} [password] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserResetPasswordPasswordGet(id: number, password?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserResetPasswordPasswordGet(id, password, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset Password
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserResetPasswordPost(resetPasswordRequest?: ResetPasswordRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserResetPasswordPost(resetPasswordRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get User Roles By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserRolesIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRolesResponseIResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserRolesIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Roles for User
         * @param {string} id 
         * @param {UpdateUserRolesRequest} [updateUserRolesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserRolesIdPut(id: string, updateUserRolesRequest?: UpdateUserRolesRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserRolesIdPut(id, updateUserRolesRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change state User
         * @param {SetStatesUserCommand} [setStatesUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserSetStatesPatch(setStatesUserCommand?: SetStatesUserCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserSetStatesPatch(setStatesUserCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Toggle User Status (Activate and Deactivate)
         * @param {ToggleUserStatusRequest} [toggleUserStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiUserToggleStatusPost(toggleUserStatusRequest?: ToggleUserStatusRequest, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiUserToggleStatusPost(toggleUserStatusRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary change Password
         * @param {ChangePasswordRequest} [changePasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserChangePasswordPost(changePasswordRequest?: ChangePasswordRequest, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserChangePasswordPost(changePasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Confirm Email
         * @param {number} [userId] 
         * @param {string} [code] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserConfirmEmailGet(userId?: number, code?: string, options?: any): AxiosPromise<StringIResult> {
            return localVarFp.apiUserConfirmEmailGet(userId, code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit User
         * @param {EditUserCommand} [editUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserEditUserPost(editUserCommand?: EditUserCommand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserEditUserPost(editUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Forgot Password
         * @param {string} [email] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserForgotPasswordPost(email?: string, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserForgotPasswordPost(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetCurrentUserManagedVendorGet(options?: any): AxiosPromise<Array<Vendor>> {
            return localVarFp.apiUserGetCurrentUserManagedVendorGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserGetCurrentUserProductTypeGet(options?: any): AxiosPromise<Array<ProductType>> {
            return localVarFp.apiUserGetCurrentUserProductTypeGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserIdGet(id: number, options?: any): AxiosPromise<UserResponseIResult> {
            return localVarFp.apiUserIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedUserQuery} [getPagedUserQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPagedPost(getPagedUserQuery?: GetPagedUserQuery, options?: any): AxiosPromise<UserDtoPaginatedResult> {
            return localVarFp.apiUserPagedPost(getPagedUserQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register User
         * @param {RegisterUserCommand} [registerUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserPost(registerUserCommand?: RegisterUserCommand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserPost(registerUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary reset password
         * @param {number} id 
         * @param {string} [password] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserResetPasswordPasswordGet(id: number, password?: string, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserResetPasswordPasswordGet(id, password, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset Password
         * @param {ResetPasswordRequest} [resetPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserResetPasswordPost(resetPasswordRequest?: ResetPasswordRequest, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserResetPasswordPost(resetPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User Roles By Id
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRolesIdGet(id: number, options?: any): AxiosPromise<UserRolesResponseIResult> {
            return localVarFp.apiUserRolesIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Roles for User
         * @param {string} id 
         * @param {UpdateUserRolesRequest} [updateUserRolesRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserRolesIdPut(id: string, updateUserRolesRequest?: UpdateUserRolesRequest, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserRolesIdPut(id, updateUserRolesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change state User
         * @param {SetStatesUserCommand} [setStatesUserCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserSetStatesPatch(setStatesUserCommand?: SetStatesUserCommand, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserSetStatesPatch(setStatesUserCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Toggle User Status (Activate and Deactivate)
         * @param {ToggleUserStatusRequest} [toggleUserStatusRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiUserToggleStatusPost(toggleUserStatusRequest?: ToggleUserStatusRequest, options?: any): AxiosPromise<IResult> {
            return localVarFp.apiUserToggleStatusPost(toggleUserStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary change Password
     * @param {ChangePasswordRequest} [changePasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserChangePasswordPost(changePasswordRequest?: ChangePasswordRequest, options?: any) {
        return UserApiFp(this.configuration).apiUserChangePasswordPost(changePasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Confirm Email
     * @param {number} [userId] 
     * @param {string} [code] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserConfirmEmailGet(userId?: number, code?: string, options?: any) {
        return UserApiFp(this.configuration).apiUserConfirmEmailGet(userId, code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit User
     * @param {EditUserCommand} [editUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserEditUserPost(editUserCommand?: EditUserCommand, options?: any) {
        return UserApiFp(this.configuration).apiUserEditUserPost(editUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Forgot Password
     * @param {string} [email] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserForgotPasswordPost(email?: string, options?: any) {
        return UserApiFp(this.configuration).apiUserForgotPasswordPost(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserGetCurrentUserManagedVendorGet(options?: any) {
        return UserApiFp(this.configuration).apiUserGetCurrentUserManagedVendorGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserGetCurrentUserProductTypeGet(options?: any) {
        return UserApiFp(this.configuration).apiUserGetCurrentUserProductTypeGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User By Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserIdGet(id: number, options?: any) {
        return UserApiFp(this.configuration).apiUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedUserQuery} [getPagedUserQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserPagedPost(getPagedUserQuery?: GetPagedUserQuery, options?: any) {
        return UserApiFp(this.configuration).apiUserPagedPost(getPagedUserQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register User
     * @param {RegisterUserCommand} [registerUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserPost(registerUserCommand?: RegisterUserCommand, options?: any) {
        return UserApiFp(this.configuration).apiUserPost(registerUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary reset password
     * @param {number} id 
     * @param {string} [password] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserResetPasswordPasswordGet(id: number, password?: string, options?: any) {
        return UserApiFp(this.configuration).apiUserResetPasswordPasswordGet(id, password, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset Password
     * @param {ResetPasswordRequest} [resetPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserResetPasswordPost(resetPasswordRequest?: ResetPasswordRequest, options?: any) {
        return UserApiFp(this.configuration).apiUserResetPasswordPost(resetPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User Roles By Id
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserRolesIdGet(id: number, options?: any) {
        return UserApiFp(this.configuration).apiUserRolesIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Roles for User
     * @param {string} id 
     * @param {UpdateUserRolesRequest} [updateUserRolesRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserRolesIdPut(id: string, updateUserRolesRequest?: UpdateUserRolesRequest, options?: any) {
        return UserApiFp(this.configuration).apiUserRolesIdPut(id, updateUserRolesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change state User
     * @param {SetStatesUserCommand} [setStatesUserCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserSetStatesPatch(setStatesUserCommand?: SetStatesUserCommand, options?: any) {
        return UserApiFp(this.configuration).apiUserSetStatesPatch(setStatesUserCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Toggle User Status (Activate and Deactivate)
     * @param {ToggleUserStatusRequest} [toggleUserStatusRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public apiUserToggleStatusPost(toggleUserStatusRequest?: ToggleUserStatusRequest, options?: any) {
        return UserApiFp(this.configuration).apiUserToggleStatusPost(toggleUserStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VendorUserApi - axios parameter creator
 * @export
 */
export const VendorUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {EditUserVendorCommand} [editUserVendorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorUserEditPatch: async (editUserVendorCommand?: EditUserVendorCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/VendorUser/Edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editUserVendorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorUserIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVendorUserIdGet', 'id', id)
            const localVarPath = `/api/VendorUser/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorUserApi - functional programming interface
 * @export
 */
export const VendorUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorUserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {EditUserVendorCommand} [editUserVendorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorUserEditPatch(editUserVendorCommand?: EditUserVendorCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVendor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorUserEditPatch(editUserVendorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorUserIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserVendor>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorUserIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VendorUserApi - factory interface
 * @export
 */
export const VendorUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorUserApiFp(configuration)
    return {
        /**
         * 
         * @param {EditUserVendorCommand} [editUserVendorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorUserEditPatch(editUserVendorCommand?: EditUserVendorCommand, options?: any): AxiosPromise<UserVendor> {
            return localVarFp.apiVendorUserEditPatch(editUserVendorCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorUserIdGet(id: number, options?: any): AxiosPromise<UserVendor> {
            return localVarFp.apiVendorUserIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendorUserApi - object-oriented interface
 * @export
 * @class VendorUserApi
 * @extends {BaseAPI}
 */
export class VendorUserApi extends BaseAPI {
    /**
     * 
     * @param {EditUserVendorCommand} [editUserVendorCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorUserApi
     */
    public apiVendorUserEditPatch(editUserVendorCommand?: EditUserVendorCommand, options?: any) {
        return VendorUserApiFp(this.configuration).apiVendorUserEditPatch(editUserVendorCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorUserApi
     */
    public apiVendorUserIdGet(id: number, options?: any) {
        return VendorUserApiFp(this.configuration).apiVendorUserIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * VendorsApi - axios parameter creator
 * @export
 */
export const VendorsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserVendorModel} [userVendorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsAddUsersPost: async (userVendorModel?: UserVendorModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vendors/AddUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userVendorModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsGetUsersIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVendorsGetUsersIdGet', 'id', id)
            const localVarPath = `/api/Vendors/GetUsers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsGetUsersNotAddIdGet: async (id: number, search?: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVendorsGetUsersNotAddIdGet', 'id', id)
            const localVarPath = `/api/Vendors/GetUsersNotAdd/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVendorsIdGet', 'id', id)
            const localVarPath = `/api/Vendors/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsIdSetStatesPatch: async (id: number, states?: StatesEnum, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVendorsIdSetStatesPatch', 'id', id)
            const localVarPath = `/api/Vendors/{id}/SetStates`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (states !== undefined) {
                localVarQueryParameter['states'] = states;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {GetPagedVendorsQuery} [getPagedVendorsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsPagedPost: async (getPagedVendorsQuery?: GetPagedVendorsQuery, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vendors/Paged`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getPagedVendorsQuery, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AddEditVendorCommand} [addEditVendorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsPost: async (addEditVendorCommand?: AddEditVendorCommand, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vendors`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addEditVendorCommand, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserVendorModel} [userVendorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsRemoveUserPost: async (userVendorModel?: UserVendorModel, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Vendors/RemoveUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userVendorModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsSwitchIdGet: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiVendorsSwitchIdGet', 'id', id)
            const localVarPath = `/api/Vendors/Switch/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VendorsApi - functional programming interface
 * @export
 */
export const VendorsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VendorsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {UserVendorModel} [userVendorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsAddUsersPost(userVendorModel?: UserVendorModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsAddUsersPost(userVendorModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsGetUsersIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsGetUsersIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsGetUsersNotAddIdGet(id: number, search?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsGetUsersNotAddIdGet(id, search, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsIdSetStatesPatch(id, states, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {GetPagedVendorsQuery} [getPagedVendorsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsPagedPost(getPagedVendorsQuery?: GetPagedVendorsQuery, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VendorPaginatedResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsPagedPost(getPagedVendorsQuery, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {AddEditVendorCommand} [addEditVendorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsPost(addEditVendorCommand?: AddEditVendorCommand, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Int32Result>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsPost(addEditVendorCommand, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {UserVendorModel} [userVendorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsRemoveUserPost(userVendorModel?: UserVendorModel, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsRemoveUserPost(userVendorModel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiVendorsSwitchIdGet(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiVendorsSwitchIdGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VendorsApi - factory interface
 * @export
 */
export const VendorsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VendorsApiFp(configuration)
    return {
        /**
         * 
         * @param {UserVendorModel} [userVendorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsAddUsersPost(userVendorModel?: UserVendorModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiVendorsAddUsersPost(userVendorModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsGetUsersIdGet(id: number, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.apiVendorsGetUsersIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsGetUsersNotAddIdGet(id: number, search?: string, options?: any): AxiosPromise<Array<UserDto>> {
            return localVarFp.apiVendorsGetUsersNotAddIdGet(id, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsIdGet(id: number, options?: any): AxiosPromise<VendorResult> {
            return localVarFp.apiVendorsIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {StatesEnum} [states] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiVendorsIdSetStatesPatch(id, states, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {GetPagedVendorsQuery} [getPagedVendorsQuery] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsPagedPost(getPagedVendorsQuery?: GetPagedVendorsQuery, options?: any): AxiosPromise<VendorPaginatedResult> {
            return localVarFp.apiVendorsPagedPost(getPagedVendorsQuery, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {AddEditVendorCommand} [addEditVendorCommand] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsPost(addEditVendorCommand?: AddEditVendorCommand, options?: any): AxiosPromise<Int32Result> {
            return localVarFp.apiVendorsPost(addEditVendorCommand, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {UserVendorModel} [userVendorModel] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsRemoveUserPost(userVendorModel?: UserVendorModel, options?: any): AxiosPromise<boolean> {
            return localVarFp.apiVendorsRemoveUserPost(userVendorModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiVendorsSwitchIdGet(id: number, options?: any): AxiosPromise<TokenResponse> {
            return localVarFp.apiVendorsSwitchIdGet(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VendorsApi - object-oriented interface
 * @export
 * @class VendorsApi
 * @extends {BaseAPI}
 */
export class VendorsApi extends BaseAPI {
    /**
     * 
     * @param {UserVendorModel} [userVendorModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsAddUsersPost(userVendorModel?: UserVendorModel, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsAddUsersPost(userVendorModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsGetUsersIdGet(id: number, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsGetUsersIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsGetUsersNotAddIdGet(id: number, search?: string, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsGetUsersNotAddIdGet(id, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsIdGet(id: number, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {StatesEnum} [states] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsIdSetStatesPatch(id: number, states?: StatesEnum, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsIdSetStatesPatch(id, states, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {GetPagedVendorsQuery} [getPagedVendorsQuery] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsPagedPost(getPagedVendorsQuery?: GetPagedVendorsQuery, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsPagedPost(getPagedVendorsQuery, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {AddEditVendorCommand} [addEditVendorCommand] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsPost(addEditVendorCommand?: AddEditVendorCommand, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsPost(addEditVendorCommand, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {UserVendorModel} [userVendorModel] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsRemoveUserPost(userVendorModel?: UserVendorModel, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsRemoveUserPost(userVendorModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VendorsApi
     */
    public apiVendorsSwitchIdGet(id: number, options?: any) {
        return VendorsApiFp(this.configuration).apiVendorsSwitchIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }
}


